import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Modal,
  TextField,
  Typography,
  Tabs,
  Tab,
  Paper,
  Alert,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Checkbox,
  FormControlLabel,
  Card,
  CardContent,
  Divider,
  CircularProgress,
  Tooltip,
  Backdrop
} from "@mui/material";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import SendIcon from '@mui/icons-material/Send';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import PriorityEmailTableAccordion from "./PriorityEmailTableAccordion";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import { useMaterialUIController } from "../../context";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { MaterialReactTable } from "material-react-table";
import Snackbar from "@mui/material/Snackbar";
import AsyncSearch from "../../components/AsyncSearch";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import {Stack} from "@mui/system";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import * as XLSX from "xlsx";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import ListItemText from "@mui/material/ListItemText";
import {getCurrentUser} from "aws-amplify/auth";
import {makeVideoThumb} from "../godsblueeye";
const CONTRACT_TYPES = {
  1: "חוזה ניהול תשלומים מלא דרך החברה",
  2: "חוזה ניהול תשלומים מלא דרך החברה וכולל ערבות בנקאית",
  3: "חוזה ניהול תשלומים חלקי, אשראי-עצמאי, פנגו וסלו דרך החברה",
  4: "חוזה ניהול תשלומים עצמאי מלא על ידי הלקוח",
};

const CopyableCell = ({ value }) => {
    const handleCopy = () => {
        navigator.clipboard.writeText(String(value));
    };
    return (
        <Box>
           {value}
            <IconButton size="small" onClick={handleCopy}>
                <ContentCopyIcon fontSize="small" />
            </IconButton>
        </Box>
    );
};
const PAY_CONDITIONS = [
    "שוטף + 60",
    "שוטף + 45",
    "שוטף + 30",
    "שוטף + 15",
    "שוטף + 7",
    "שוטף + 1",
];

const DEFAULT_PAY_CONDITION = "שוטף + 60";
const getImageSrc = (att) => {
    if (att.thumbUrl) return att.thumbUrl;
    if (att.type.startsWith("image/")) {
        // fallback: add a resize query param (if CDN/S3 signed URLs support it)
        return `${att.url}?w=80&h=80&fit=crop`;
    }
    return att.url;
};

const handleDownload = (url, fileName) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
};

const renderAttachmentPreview = (att, idx) => {
    // ---------- images ----------
    if (att.type.startsWith("image/")) {
        return (
            <img
                src={getImageSrc(att)}
                alt={att.fileName}
                width={80}
                height={80}
                style={{ objectFit: "cover", cursor: "pointer", marginRight: 4 }}
                onClick={() => handleDownload(att.url, att.fileName)}
            />
        );
    }


    // ---------- videos ----------
    if (att.type.startsWith("video/")) {
        if(att.thumbUrl){
            return (
                <img
                    src={att?.thumbUrl}
                    alt={att.fileName}
                    width={80}
                    height={80}
                    loading="lazy"
                    style={{ objectFit: "cover", cursor: "pointer", marginRight: 4 }}
                    onClick={() => handleDownload(att.url, att.fileName)}
                />
            )
        }
        else {
            return (<Grid item key={idx}>
                    <video
                        src={att.url}
                        muted
                        preload="metadata"  // this helps load just video metadata (not full file)
                        style={{
                            width: 80,
                            height: 80,
                            cursor: "pointer",
                            objectFit: "cover"
                        }}
                        onClick={() => handleDownload(att.url, att.fileName)}
                    />
                </Grid>
            )
        }

    }


    return (
        <Button
            variant="text"
            color="info"
            onClick={() => handleDownload(att.url, att.fileName)}
        >
            {att.name}
        </Button>
    );
};

const PlaceCommissions = () => {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const pageBackground = darkMode ? "#1A2035" : "#F5F5F5";
    const textColor = darkMode ? "#ffffff" : "#000000";
    const paperBg = darkMode ? "#27293d" : "#ffffff";
    const [paymentOpen, setPaymentOpen] = useState(false);
    const [payCondConfirm, setPayCondConfirm] = useState({ open: false, pendingValue: null });

    const [userEmail, setUserEmail] = useState("");
    const [paymentRow, setPaymentRow] = useState(null);
    const [notifyOpen, setNotifyOpen] = useState(false);
    const [notifyRow, setNotifyRow] = useState(null);
    const [notifySending, setNotifySending] = useState(false);
    const [resetOpen, setResetOpen] = useState(false);
    const [resetRow, setResetRow] = useState(null);
    const [resetSelected, setResetSelected] = useState([]); // ["1","2","3"]
    const [resetSending, setResetSending] = useState(false);
    const [notifyChannels, setNotifyChannels] = useState({ email: true, whatsapp: false });
    const [logs, setLogs] = useState([]);
    const [logsLoading, setLogsLoading] = useState(false);
    const [logsError, setLogsError] = useState("");
    const [logsRowCount, setLogsRowCount] = useState(0);
    const [logsHasLoadedOnce, setLogsHasLoadedOnce] = useState(false);
    const [debtModalOpen, setDebtModalOpen] = useState(false);
    const [debtForm, setDebtForm] = useState({ amount: '', date: '', email: '', phone: '' });
    const [debtRow, setDebtRow] = useState(null);
    // MRT server-side pagination state (0-based)
    const [logsPagination, setLogsPagination] = useState({ pageIndex: 0, pageSize: 10 });
    const [sendDebtOpen, setSendDebtOpen] = useState(false);
    const [sendDebtRow, setSendDebtRow] = useState(null);
    const [sendDebtForm, setSendDebtForm] = useState({
        name: '',
        email: '',
        phone: '', 
        amount: '',
        attachmentUrl: '',
        attachmentName: '',
        includeAttachment: false,
        channels: { email: true, whatsapp: false },
    });
    const closeDebtModal = () => {
        setDebtModalOpen(false);
        setDebtRow(null);
    };

    const handleDebtCreate = async () => {
        if (!debtRow) return;
        if (!debtForm.amount || !debtForm.date) {
            setSnackbar({ open: true, severity: 'warning', message: 'מלא את כל השדות' });
            return;
        }


        const prio = (priorityData || []).find(
            (p) => String(p.clientNumber) === String(debtRow.clientNum)
        );

        try {
            setDebtCreating(true);
            const resp = await fetch('https://blue-parking-invite.bluept.dev/api/finance/debt-demand', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    placeId: debtRow.placeId,
                    amount: Number(debtForm.amount),
                    debtDate: debtForm.date,
                    email: debtForm.email || '',
                    phone: debtForm.phone ||  '',
                    companyName: debtRow.companyName || ''
                }),
            });
            if (!resp.ok) throw new Error('HTTP ' + resp.status);
            setSnackbar({ open: true, severity: 'success', message: 'החוב נוצר' });
            closeDebtModal();
        } catch (e) {
            console.error(e);
            setSnackbar({ open: true, severity: 'error', message: 'יצירת חוב נכשלה' });
        } finally {
            setDebtCreating(false);
        }
    };

    
     function toGMT3DateTime(utcString) {
           if (!utcString) return "";
           const d = new Date(utcString);
           const gmt3 = new Date(d.getTime() + 6 * 60 * 60 * 1000);
           const [date, time] = gmt3.toISOString().split("T");
           return `${date} ${time.slice(0,5)}`; // YYYY-MM-DD HH:MM
         }

    function handlePayCondChange(nextValue) {
        if (nextValue !== DEFAULT_PAY_CONDITION) {
            setPayCondConfirm({ open:true, pendingValue: nextValue });
        } else {
            setForm(prev => ({ ...prev, pay_condition: nextValue }));
        }
    }

     const fetchFinanceLogs = async ({ pageIndex, pageSize }) => {
           setLogsLoading(true);
           setLogsError("");
           try {
                 // API to create (see server snippet below)
                     const res = await fetch(
                       `https://blue-parking-invite.bluept.dev/finance/logs?page=${pageIndex + 1}&pageSize=${pageSize}`
                     );
                 if (!res.ok) {
                       const txt = await res.text().catch(() => "");
                       throw new Error(txt || `HTTP ${res.status}`);
                     }
                 const { data, total } = await res.json();
                 setLogs(data || []);
                 setLogsRowCount(total || 0);
                 setLogsHasLoadedOnce(true);
               } catch (e) {
                 console.error(e);
                 setLogsError(String(e));
               } finally {
                 setLogsLoading(false);
               }
         };

    const openPayment  = React.useCallback((row) => { setPaymentRow(row); setPaymentOpen(true); }, []);
    const closePayment = () => { setPaymentOpen(false); setPaymentRow(null); };
    function toGMT3DateOnly(utcString) {
        // Parse as Date (UTC)
        if(!utcString) return "";
        const date = new Date(utcString);

        // Shift by +3 hours (in ms)
        const gmt3 = new Date(date.getTime() + 3 * 60 * 60 * 1000);

        // Format to YYYY-MM-DD (no hours)
        return gmt3.toISOString().split("T")[0];
    }
     // Which fields to clear per stage
         const RESET_OPTIONS = [
           { value: "1", label: "איפוס התראה ראשונה",
             fields: ["sentFirstRequest","dateSentFirstRequest","sentFinanceFirst","dateSentFirstRequest"] },
       { value: "2", label: "איפוס התראה שנייה",
         fields: ["sentRequest","dateSentSecondRequest","sentFinanceSecond","dateSentSecondRequest"] },
       { value: "3", label: "איפוס התראה שלישית",
         fields: ["needsFullDisconnection","dateSentThirdRequest","sentFinanceThird","dateSentThirdRequest"] },
     ];

         const openReset = (row) => {
           setResetRow(row);
           setResetSelected([]);
           setResetOpen(true);
         };
     const closeReset = () => {
           setResetOpen(false);
           setResetRow(null);
           setResetSelected([]);
         };

     const handleResetSubmit = async () => {
           if (!resetRow || !resetSelected?.length) return;
           const selectedStages = resetSelected.map(Number);
           const selectedOptions = RESET_OPTIONS.filter(o => resetSelected.includes(o.value));
           // union of fields across all selected stages
               const fieldsUnion = [...new Set(selectedOptions.flatMap(o => o.fields))];
        setResetSending(true);
           try {
                 // 🔧 adjust endpoint if you named it differently
                     const res = await fetch("https://blue-parking-invite.bluept.dev/finance/reset-alerts", {
                       method: "POST",
                       headers: { "Content-Type": "application/json" },
                         body: JSON.stringify({ items: [{ placeId: resetRow.placeId, stages: selectedStages, clientName: resetRow?.clientName }], user: {email: userEmail} })
                 });
                 if (!res.ok) {
                       const text = await res.text().catch(() => "");
                       throw new Error(text || `HTTP ${res.status}`);
                     }

                     // Optimistic UI: clear the chosen fields in the local table
                         setPriorityData(prev => prev.map(r => {
                               if (String(r.placeId) !== String(resetRow.placeId)) return r;
                               const patch = {};
                             fieldsUnion.forEach(f => { if (f in r) patch[f] = null; });
                               return { ...r, ...patch };
                             }));

                     setSnackbar({ open: true, severity: "success", message: "האיפוס בוצע בהצלחה" });
                 closeReset();
               } catch (e) {
                 console.error(e);
                 setSnackbar({ open: true, severity: "error", message: `האיפוס נכשל: ${String(e)}` });
               } finally {
                 setResetSending(false);
               }
         };

    const toNum = (v) => (Number.isFinite(+v) ? +v : 0);
    const fmtILS = (v) =>
        new Intl.NumberFormat('he-IL', {
            style: 'currency',
            currency: 'ILS',
            currencyDisplay: 'narrowSymbol',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(toNum(v));

    const computeNextStage = (r) => {
        // treat any non-empty value as "already sent"
        const sent1 = !!r?.dateSentFirstRequest;         // שלב 1
        const sent2 = !!r?.dateSentSecondRequest;              // שלב 2
        const sent3 = !!r?.dateSentThirdRequest;   // שלב 3

        const sentCount = [sent1, sent2, sent3].filter(Boolean).length;
        if (sentCount >= 3) return null;        // nothing left to send
        return sentCount + 1;                   // 1 → 2 → 3
    };

    const stageToTemplateKey = (stage) => {
        // match these keys with what your server expects
        return stage === 1 ? 'LETTER_1'
            : stage === 2 ? 'LETTER_2'
                : 'LETTER_3';
    };
    // Decide which alert label to show based on steps
    const getNextAlertLabel = (r) => {
        const step1 = !!r?.dateSentFirstRequest;   // שלב 1
        const step2 = !!r?.dateSentSecondRequest;        // שלב 2
        const step3 = !!r?.dateSentThirdRequest; // שלב 3

        // if step2 is already filled -> the next we show as "התראה שלישית"
        if (step2) return 'התראה שלישית';
        // if only step1 is filled -> next is "התראה שנייה"
        if (step1) return 'התראה שנייה';
        // otherwise assume first
        return 'התראה ראשונה';
    };

    const openNotify = (row) => {
        setNotifyRow(row);
        setNotifyChannels({ email: true, whatsapp: false });
        setNotifyOpen(true);
    };

    const closeNotify = () => {
        setNotifyOpen(false);
        setNotifyRow(null);
    };

     const logsColumns = useMemo(() => [
           // { accessorKey: 'id', header: 'ID', size: 80 },
           {
             accessorKey: 'occurred_at',
             header: 'זמן הפעולה',
             Cell: ({ cell }) => toGMT3DateTime(cell.getValue()),
             size: 180,
           },
       { accessorKey: 'action', header: 'פעולה', size: 180 },
           { accessorKey: 'user_email', header: 'משתמש', size: 220 },
       {
         accessorKey: 'success',
             header: 'הצלחה',
             size: 100,
             Cell: ({ cell }) => (cell.getValue() ? '✔' : '✘'),
           },
       {
         accessorKey: 'error_message',
             header: 'שגיאה',
             size: 400,
             Cell: ({ cell }) => {
               const v = cell.getValue();
               if (!v) return '—';
               const txt = String(v);
               return (
                     <span title={txt}>
           {txt.length > 120 ? `${txt.slice(0, 120)}…` : txt}
                         </span>
                   );
             },
           },
     ], []);

    const paymentColumns = useMemo(() => [
        { accessorKey: 'period', header: '', size: 50 },

        {
            accessorKey: 'pango',
            header: 'פנגו',
            size: 50,
            muiTableHeadCellProps: { align: 'right' },
            Cell: ({ cell }) => (
                <Box component="span" sx={{ direction: 'ltr', display: 'inline-block', textAlign: 'right', fontVariantNumeric: 'tabular-nums', width: '100%' }}>
                    {fmtILS(cell.getValue())}
                </Box>
            ),
        },
        {
            accessorKey: 'cello',
            header: 'סלו',
            size: 50,
            muiTableHeadCellProps: { align: 'right' },
            Cell: ({ cell }) => (
                <Box component="span" sx={{ direction: 'ltr', display: 'inline-block', textAlign: 'right', fontVariantNumeric: 'tabular-nums', width: '100%' }}>
                    {fmtILS(cell.getValue())}
                </Box>
            ),
        },
        {
            accessorKey: 'credit',
            header: 'אשראי',
            size: 50,
            muiTableHeadCellProps: { align: 'right' },
            Cell: ({ cell }) => (
                <Box component="span" sx={{ direction: 'ltr', display: 'inline-block', textAlign: 'right', fontVariantNumeric: 'tabular-nums', width: '100%' }}>
                    {fmtILS(cell.getValue())}
                </Box>
            ),
        },
        {
            accessorKey: 'total',
            header: 'סה"כ',
            muiTableHeadCellProps: { align: 'right' },
            size: 50,
            Cell: ({ cell }) => (
                <Box component="span" sx={{ direction: 'ltr', display: 'inline-block', textAlign: 'right', fontVariantNumeric: 'tabular-nums', width: '100%' }}>
                    {fmtILS(cell.getValue())}
                </Box>
            ),
        },
    ], []);

    const paymentData = useMemo(() => {
        if (!paymentRow) return [];
        const current = {
            period: 'חודש נוכחי',
            pango:  toNum(paymentRow.pango),
            cello:  toNum(paymentRow.cello),
            credit: toNum(paymentRow.credit),
        };
        current.total = current.pango + current.cello + current.credit;

        const previous = {
            period: 'חודש קודם',
            pango:  toNum(paymentRow.prevPango),
            cello:  toNum(paymentRow.prevCello),
            credit: toNum(paymentRow.prevCredit),
        };
        previous.total = previous.pango + previous.cello + previous.credit;

        return [current, previous];
    }, [paymentRow]);



    const [tabIndex, setTabIndex] = useState(0);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [contractFrom, setContractFrom] = useState("");
    const [contractTo, setContractTo] = useState("");
    const [revenues, setRevenues] = useState(null); // array from /api/revenues
    const [revenuesLoading, setRevenuesLoading] = useState(false);
    const [editPriorityOpen, setEditPriorityOpen] = useState(false);
    const [priorityForm, setPriorityForm]         = useState(null);
    const [debtCreating, setDebtCreating] = useState(false);
    // const contractSummary = useMemo(() => {
    //   const map = {};
    //   (data || []).forEach((row) => {
    //     const ct = String(row.contractType ?? "unknown");
    //     if (!map[ct]) map[ct] = { count: 0, pango: 0, cello: 0, credit: 0 };
    //     map[ct].count += 1;
    //     map[ct].pango += toNum(row.pango);
    //     map[ct].cello += toNum(row.cello);
    //     map[ct].credit += toNum(row.credit);
    //   });
    //   return Object.entries(map).map(([contractType, stats]) => ({
    //     contractType,
    //     label: CONTRACT_TYPES[contractType] || `Type ${contractType}`,
    //     ...stats,
    //     total: stats.pango + stats.cello + stats.credit,
    //   })).sort((a,b)=>a.contractType.localeCompare(b.contractType));
    // }, [data]);

//     const contractSummary = useMemo(() => {
//     const map = {};
//     (data || []).forEach((row) => {
//     const ct = String(row.contractType ?? "unknown");
//     if (!map[ct])
//       map[ct] = {
//         count: 0,
//         pango: 0,
//         cello: 0,
//         credit: 0,
//         pangoCommission: 0,
//         celloCommission: 0,
//         ccardCommission: 0,
//     };
    
//     const pango = toNum(row.pango);
//     const cello = toNum(row.cello);
//     const credit = toNum(row.credit);
//     const pangoPct = toNum(row.pangoCommissionPercentage);
//     const celloPct = toNum(row.celloCommissionPercentage);
//     const ccardPct = toNum(row.ccardCommissionPercentage);

//     map[ct].count += 1;
//     map[ct].pango += pango;
//     map[ct].cello += cello;
//     map[ct].credit += credit;

//     // commission amounts = gross * commission percentage
//     map[ct].pangoCommission += pango * pangoPct;
//     map[ct].celloCommission += cello * celloPct;
//     map[ct].ccardCommission += credit * ccardPct;
//   });

//   return Object.entries(map)
//     .map(([contractType, stats]) => ({
//       contractType,
//       label: CONTRACT_TYPES[contractType] || `Type ${contractType}`,
//       ...stats,
//       total: stats.pango + stats.cello + stats.credit,
//       commissionTotal:
//         stats.pangoCommission + stats.celloCommission + stats.ccardCommission,
//     }))
//     .sort((a, b) => a.contractType.localeCompare(b.contractType));
//     }, [data]);

    const contractSummary = useMemo(() => {
  // helper to start from an empty accumulator per contractType
    const makeEmpty = () => ({
        count: 0,
        pango: 0,
        cello: 0,
        credit: 0,
        pangoCommission: 0,
        celloCommission: 0,
        ccardCommission: 0,
    });

    const map = {};
    const VAT = 1.18;

    // If revenues are available and a date range was picked, aggregate from revenues.
    if (contractFrom && contractTo && Array.isArray(revenues)) {
        const placesById = (data || []).reduce((acc, p) => {
            const id = String(p.placeId ?? "").trim().toLowerCase();
            console.log(id)
            if (id) acc[id] = p;
            return acc;
        }, {});

        // iterate API revenues so counts reflect the API response
        revenues.forEach((rev) => {
            const pid = String(rev.data_placeId ?? "").trim().toLowerCase();
            const place = placesById[pid];
            if(!place) return
            const ct = String(place?.contractType ?? "unknown");

            if (!map[ct]) map[ct] = makeEmpty();

            const pangoRev = toNum(rev.Pango);
            const celloRev = toNum(rev.Cellopark ?? rev.Cello ?? 0);
            const creditRev = toNum(rev.Credit_card ?? rev.Credit ?? 0);


            map[ct].count +=1;
            map[ct].pango += pangoRev;
            map[ct].cello += celloRev;
            map[ct].credit += creditRev;

            // use local commission percentages if place exists, otherwise 0
            const pangoPct = place ? toNum(place.pangoCommissionPercentage) : 0;
            const celloPct = place ? toNum(place.celloCommissionPercentage) : 0;
            const ccardPct = place ? toNum(place.ccardCommissionPercentage) : 0;

            map[ct].pangoCommission += pangoRev * pangoPct * VAT;
            map[ct].celloCommission += celloRev * celloPct * VAT;
            map[ct].ccardCommission += creditRev * ccardPct * VAT;
        });
    } else {
        // fallback: original behaviour - aggregate using the values stored on each local row
        (data || []).forEach((row) => {
            if (row.pango == null && row.cello == null && row.credit == null) return;
            const ct = String(row.contractType ?? "unknown");
            if (!map[ct]) map[ct] = makeEmpty();

            const pango = toNum(row.pango);
            const cello = toNum(row.cello);
            const credit = toNum(row.credit);
            const pangoPct = toNum(row.pangoCommissionPercentage);
            const celloPct = toNum(row.celloCommissionPercentage);
            const ccardPct = toNum(row.ccardCommissionPercentage);

            map[ct].count += 1;
            map[ct].pango += pango;
            map[ct].cello += cello;
            map[ct].credit += credit;

            map[ct].pangoCommission += pango * pangoPct * VAT;
            map[ct].celloCommission += cello * celloPct * VAT;
            map[ct].ccardCommission += credit * ccardPct * VAT;
        });
    }

    Object.keys(CONTRACT_TYPES).forEach((k) => {
        // skip type 2 as requested
        if (k === "2") return;
        if (!map[k]) {
            map[k] = makeEmpty();
            // mark as placeholder so UI can show "No data" for contracts
            map[k]._noData = true;
        }
    });

    return Object.entries(map)
        .map(([contractType, stats]) => ({
        contractType,
        label: CONTRACT_TYPES[contractType] || `Type ${contractType}`,
        ...stats,
        total: stats.pango + stats.cello + stats.credit,
        commissionTotal:
            stats.pangoCommission + stats.celloCommission + stats.ccardCommission,
        noData: !!stats._noData,    
        }))
        .sort((a, b) => a.contractType.localeCompare(b.contractType));
    }, [data, contractFrom, contractTo, revenues]);

// open it with the selected row
    const handleOpenPriorityEdit = (record) => {
        setOriginalPlaceId(record.placeId);
        setPriorityForm({
            ...record,
            // you probably want to keep two arrays:
            attachments:    record.attachments || [],
            newAttachments: [],
        });
        setEditPriorityOpen(true);
    };

    const handleSendNotification = async () => {
        if (!notifyRow) return;

        // require at least one channel
        if (!notifyChannels.email && !notifyChannels.whatsapp) {
            setSnackbar({ open: true, severity: 'warning', message: 'בחר לפחות ערוץ אחד לשליחה' });
            return;
        }

        const stage = computeNextStage(notifyRow);
        if (!stage) {
            setSnackbar({ open: true, severity: 'info', message: 'כבר נשלחו כל 3 ההתראות ללקוח זה' });
            return;
        }

        const payload = {
            stage,                                  // 1 | 2 | 3
            user:{email: userEmail},
            template: stageToTemplateKey(stage),    // 'LETTER_1' | 'LETTER_2' | 'LETTER_3'
            channels: {                             // user’s choices
                email: notifyChannels.email,
                whatsapp: notifyChannels.whatsapp,
            },
            row: {                                  // send the essentials (expand if your server needs more)
                placeId: notifyRow.placeId,
                clientNumber: notifyRow.clientNumber,
                clientName: notifyRow.clientName,
                placeName: notifyRow.placeName,
                email: notifyRow.email,
                phone: notifyRow.phone,


            },
        };

        try {
            setNotifySending(true);

            // 🔁 choose the endpoint you implement on the server:
            // e.g. POST /api/priority-receipts/send-notification
            const res = await fetch(
                'https://blue-parking-invite.bluept.dev/api/priority-receipts/send-notification',
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload),
                }
            );

            if (!res.ok) {
                const text = await res.text().catch(() => '');
                throw new Error(text || `HTTP ${res.status}`);
            }

            // Expect the server to return either the updated row or at least which stage was recorded.
            const { updatedRow, stageRecorded } = await res.json();

            // Fallback: if server didn’t echo row, update the relevant step locally with a timestamp
            const localPatched =
                updatedRow ??
                {
                    ...notifyRow,
                    ...(stage === 1
                        ? { sentFirstRequest: "נשלח", dateSentFirstRequest: new Date().toISOString() }
                        : stage === 2
                            ? { sentRequest: "נשלח" ,dateSentSecondRequest: new Date().toISOString()}
                            : { needsFullDisconnection: "כן" , dateSentThirdRequest: new Date().toISOString()}),
                };

            setPriorityData((prev) =>
                prev.map((r) =>
                    String(r.placeId) === String(localPatched.placeId) ? { ...r, ...localPatched } : r
                )
            );

            setSnackbar({
                open: true,
                severity: 'success',
                message: `התראה ${stageRecorded ?? stage} נשלחה בהצלחה`,
            });

            closeNotify();
        } catch (err) {
            console.error(err);
            setSnackbar({ open: true, severity: 'error', message: 'שליחה נכשלה' });
        } finally {
            setNotifySending(false);
        }
    };


    const handlePriorityFileChange = async (e) => {
        const picked = Array.from(e.target.files);
        const processed = await Promise.all(picked.map(processAttachment));
        const trimmed = processed.map(({ original, thumbnail, icon }) => ({
            file:       original,
            thumbFile:  thumbnail ?? null,
            iconName:   icon      ?? null,
            name:       original.name,
            type:       original.type,
            previewUrl: URL.createObjectURL(thumbnail ?? original),
        }));
        setPriorityForm(prev => ({
            ...prev,
            newAttachments: [...(prev.newAttachments||[]), ...trimmed],
        }));
    };

    const handleClosePriorityEdit = () => {
        setEditPriorityOpen(false);
        setPriorityForm(null);
    };
  const [addOpen, setAddOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const companies = ["חניה כחולה", "שדות ים"];
    const [priorityData, setPriorityData] = useState([]);
    const [loadingPriority, setLoadingPriority] = useState(false);
    const [createOpen, setCreateOpen] = useState(false);
    const initialReceipt = {
        placeId: "",
        clientNumber: null,
        clientName: "",
        placeName: "",
        email: "",
        phone: "",
        access: false,
        accessLimit: null,
        accessLastDate: "",
        accountNumber: null,
        bankNumber: null,
        bankName: "",
        companyNumber: null,
        branchNum: null,
        accessGrantDate: "",
        sentFirstRequest: "",
        disconnectedCloud: "",
        sentRequest: "",
        needsFullDisconnection: "",
        clientNotes: "",
        clientHandle: false,
    };
    const [newReceipt, setNewReceipt] = useState(initialReceipt);

    function handleDeleteRow(row) {
        // 1) Optional confirmation
        if (!window.confirm(`Delete entry for "${row.original.placeName}"?`)) return;
        // 2) Call your delete‐API
        fetch(`https://blue-parking-invite.bluept.dev/api/priority-receipts/${row.original.id}`, {
            method: 'DELETE',
        })
            .then((res) => {
                if (!res.ok) throw new Error('Delete failed');
                // 3) Remove it from local state so the table re‑renders without that row
                setPriorityData((prev) =>
                    prev.filter((r) => r.id !== row.original.id)
                );
            })
            .catch((err) => {
                console.error(err);
                setSnackbar({ open: true, message: 'Delete failed', severity: 'error' });
            });
    }

    useEffect(() => {
        (async function getUserData() {
            const data = await getCurrentUser();
            setUserEmail(data.signInDetails.loginId);
        })();
    }, []);

    useEffect(() => {
        const fetchPriority = async () => {
            setLoadingPriority(true);
            try {
                const res = await fetch("https://blue-parking-invite.bluept.dev/api/priority-receipts");
                const json = await res.json();
                setPriorityData(json.data || []);
            } catch (e) {
                console.error(e);
            } finally {
                setLoadingPriority(false);
            }
        };
      fetchPriority();
    }, []);

        const [form, setForm] = useState({
    placeId: "",
    placeName: "",
    clientNum: 0,
    companyName: "",
    pangoCommissionPercentage: 0,
    celloCommissionPercentage: 0,
    ccardCommissionPercentage: 0,
    stationsNum: 0,
    monthlyDigitalPrice: 0,
    monthlyTerminalPrice: 0,
    contractType: 1,
    priorityType: [],
    sendEmail: [],
            attachments: [],        // ← NEW
            newAttachments: [],     // ← NEW: local picked files before upload
            pay_condition: DEFAULT_PAY_CONDITION, // ← NEW
    priorityEmails: companies.reduce((acc, company) => {
      acc[company] = "";
      return acc;
    }, {}),
  });
             async function handleExport() {

                 const data = priorityData.map(ld=> ({
                     "מזהה חניון": ld.placeId,
                     "מס לקוח": ld.clientNumber,
                     "שם לקוח": ld.clientName,
                     "שם חניון": ld.placeName,
                     "אימייל - איש קשר": ld.email,
                     "איש קשר - נייד": ld.phone,
                     "האם קיימת הרשאה": ld.access,
                     "תקרת הרשאה": ld.accessLimit,
                     "מועד פקיעת הרשאה": ld.accessLastDate,
                     "מספר חשבון": ld.accountNumber,
                     "מספר בנק": ld.bankNumber,
                     "שם בנק": ld.bankName,
                     "ח.פ": ld.companyNumber,
                     "סניף": ld.branchNum,
                     "תאריך מתן הרשאה באישור מאיר": ld.accessGrantDate,
                     "שלב 1-האם נשלחה בקשה ראשונה-וואטסאפ": ld.sentFirstRequest,
                     "האם בוצע ניתוק יזום של ענן/ יוזרים": ld.disconnectedCloud,
                     "שלב 2 - האם נשלח בקשה שניה ( מייל - לאחר 48 שעות)": ld.sentRequest,
                     "שלב 3 - האם נדרש ניתוק מלא": ld.needsFullDisconnection,
                     "הערות לקוח": ld.clientNotes,
                     "נסגר טיפול בלקוח": ld.clientHandle,
                 }));
                 const ws = XLSX.utils.json_to_sheet(data);
                 const wb = XLSX.utils.book_new();
                 XLSX.utils.book_append_sheet(wb, ws, "Leads");
                 const colCount = Object.keys(data[0]).length;
                 ws['!cols'] = new Array(colCount).fill({ wpx: 280 });
                 const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

                 // 2) Ask the user where to save:
                 const pickerOpts = {
                     suggestedName: `paymentMethods.xlsx`,
                     types: [{
                         description: "Excel Workbook",
                         accept: {
                             "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"]
                         }
                     }]
                 };

                 try {
                     const handle = await window.showSaveFilePicker(pickerOpts);
                     const writable = await handle.createWritable();
                     await writable.write(new Uint8Array(wbout));
                     await writable.close();
                     console.log("Saved!");
                 } catch (err) {
                     // User may have cancelled the dialog
                     console.error("Save cancelled or failed:", err);
                 }
             }



  const [originalPlaceId, setOriginalPlaceId] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const [saving, setSaving] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await fetch("https://blue-parking-invite.bluept.dev/api/get-place-comissions");
        const json = await res.json();
        // console.log(json);
        setData(json || []);
      } catch (e) {
        console.error("Fetch failed", e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

      const handleAddPaymentMethod = (row) => {
            setNewReceipt({
                  ...initialReceipt,
                  placeId: row.placeId,
                  placeName: row.placeName,
                clientNumber: row.clientNum,
                clientName: row.companyName,
                });
            setCreateOpen(true);
          };


    const handleDelete = async (id) => {
        if (!window.confirm("האם אתה בטוח שברצונך לבצע מחיקה?")) return;

        try {
            setSaving(true);
            const resp = await fetch(`https://blue-parking-invite.bluept.dev/api/delete-place-commissions/${id}`, {
                method: 'DELETE',
            });
            if (!resp.ok) throw new Error(resp.statusText);

            // Refresh data
            const res2 = await fetch("https://blue-parking-invite.bluept.dev/api/get-place-comissions");
            const json2 = await res2.json();
            setData(json2 || []);

            setSnackbar({
                open: true,
                message: "Deleted successfully",
                severity: "success",
            });
        } catch (e) {
            console.error("Delete failed", e);
            setSnackbar({
                open: true,
                message: "Delete failed",
                severity: "error",
            });
        } finally {
            setSaving(false);
        }
    }
    const isDuplicateId = (id) => data.some((d) => d.placeId === id && id !== originalPlaceId);
    const handleDownloadPdf = (row) => {
        setDebtRow(row);
        const prio = (priorityData || []).find(
            (p) => String(p.clientNumber) === String(row.clientNum)
        );
        setDebtForm({
            amount: '',
            date: '',
            email: prio?.email ||  '',     // prefill from priority
            phone: prio?.phone ||  '',
        });
        setDebtModalOpen(true);
    }

    const handleSendDebtNotice = (row) => {
        const prio = (priorityData || []).find(
            (p) => String(p.clientNumber) === String(row.clientNum)
        );
        const defaultAttachment = (row.attachments || [])[0] || null;
        setSendDebtRow(row);
        setSendDebtForm({
            name: row.companyName || row.clientName || '',
            email: prio?.email || row.email || '',
            phone: prio?.phone || row.phone || '',
            amount: '',
            attachmentUrl: defaultAttachment?.url || '',
            attachmentName: defaultAttachment?.name || defaultAttachment?.fileName || '',
            includeAttachment: false,
            channels: { email: false, whatsapp: false },
        });
        setSendDebtOpen(true);
    }

    const closeSendDebtModal = () => {
        setSendDebtOpen(false);
        setSendDebtRow(null);
    };

    const isValidEmail = (v) =>
    !!v && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);

    const isValidPhone = (v) =>
    !!v && /^[0-9+\-()\s]{7,}$/.test(v);

    const isPositiveAmount = (v) => {
        const n = Number(v);
        return Number.isFinite(n) && n > 0;
    };

    const handleSendDebtSubmit = async () => {
        if (!sendDebtRow) return;

        if (!isPositiveAmount(sendDebtForm.amount)) {
            setSnackbar({ open: true, severity: 'warning', message: 'סכום חייב להיות גדול מ-0' });
            return;
        }

        if (sendDebtForm.includeAttachment && !sendDebtForm.attachmentUrl) {
            setSnackbar({ open: true, severity: 'warning', message: 'בחר קובץ' });
            return;
        }
        if (!sendDebtForm.channels.email && !sendDebtForm.channels.whatsapp) {
            setSnackbar({ open: true, severity: 'warning', message: 'סמן ערוץ אחד לפחות' });
            return;
        }
        if (sendDebtForm.channels.email && !isValidEmail(sendDebtForm.email)) {
            setSnackbar({ open: true, severity: 'warning', message: 'אימייל לא תקין' });
            return;
        }
        if (sendDebtForm.channels.whatsapp && !isValidPhone(sendDebtForm.phone)) {
            setSnackbar({ open: true, severity: 'warning', message: 'מספר טלפון לא תקין' });
            return;
        }

        const payment = {                  // NEW: lets backend append Tranzila link
            clientName: sendDebtForm.name,
            clientPhone: sendDebtForm.phone,
            paymentsNumber: 1,        // or your desired installments
            amount: Number(sendDebtForm.amount || 0),
            clientEmail: sendDebtForm.email,
        }

        try {
            // only build attachment if included
            const attachment = (sendDebtForm.includeAttachment && sendDebtForm.attachmentUrl)
            ? {
                url: sendDebtForm.attachmentUrl,
                filename: sendDebtForm.attachmentName || 'מסמך.pdf',
                contentType: 'application/pdf',
                type: 'application/pdf',
                }
            : null;

            // Build a short, RTL-friendly message for WhatsApp
            const amtNum = Number(sendDebtForm.amount || 0);
            const amountStr = Number.isFinite(amtNum)
            ? new Intl.NumberFormat('he-IL', { style: 'currency', currency: 'ILS', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amtNum)
            : String(sendDebtForm.amount);

            const waText = `שלום ${sendDebtForm.name || ''},
        סכום לתשלום: ${amountStr}
        מצ״ב דרישת תשלום.
        בברכה,
        מחלקת כספים`;

            const emailHtml = `<div dir="rtl" style="font-family:Arial,sans-serif">
        שלום ${sendDebtForm.name || ''},<br/>
        <strong>סכום לתשלום:</strong> <span dir="ltr">${amountStr}</span><br/>
        מצורף מסמך דרישת תשלום.<br/><br/>
        בברכה,<br/>מחלקת כספים
        </div>`;

            // Send per channel
            const tasks = [];

            if (sendDebtForm.channels.email) {
                const emailPayload = {
                    to: sendDebtForm.email,
                    subject: 'דרישת תשלום',
                    html: emailHtml,
                    userEmail,
                    payment,
                };
                if (attachment) emailPayload.attachment = attachment;
                tasks.push(fetch('https://blue-parking-invite.bluept.dev/api/finance/email', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(emailPayload),
                }));
            }

            if (sendDebtForm.channels.whatsapp) {
                const waPayload = {
                    phone: sendDebtForm.phone,
                    text: waText,
                    userEmail,
                    payment,
                };
                if (attachment) waPayload.attachment = attachment;
                tasks.push(fetch('https://blue-parking-invite.bluept.dev/api/finance/whatsapp', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(waPayload),
                }));
            }

            const resArr = await Promise.all(tasks);
            const bad = resArr.find(r => !r.ok);
            if (bad) throw new Error(`HTTP ${bad.status}`);

            setSnackbar({ open: true, severity: 'success', message: 'נשלח בהצלחה' });
            closeSendDebtModal();
        } catch (e) {
            console.error(e);
            setSnackbar({ open: true, severity: 'error', message: 'השליחה נכשלה' });
        }
    };
    const columns = useMemo(
        () => [
            {
                accessorKey: 'placeName',
                header: 'חניון',
                Cell: ({ cell }) => <CopyableCell value={cell.getValue()} />,
            },
            {
                accessorKey: 'placeId',
                header: 'מזהה חניון',
                Cell: ({ cell }) => <CopyableCell value={cell.getValue()} />,
            },
            {
                id: 'actions',
                header: 'פעולות',
                size: 200,
                muiTableHeadCellProps: { align: 'center' },
                muiTableBodyCellProps: { align: 'center' },
                Cell: ({ row }) => (
                    <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center' }}>
                        <Tooltip title="עריכה" arrow>
                            <IconButton
                                size="small"
                                color="primary"
                                onClick={() => handleEdit(row.original)}
                            >
                                <EditIcon fontSize="inherit" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="נתוני תשלום" arrow>
                            <IconButton
                                size="small"
                                onClick={() => openPayment(row.original)}
                                sx={{ p: 0.5 }}
                            >
                                <VisibilityIcon fontSize="inherit" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="PDF" arrow>
                            <IconButton
                                size="small"
                                onClick={() => handleDownloadPdf(row.original)}
                            >
                                <PictureAsPdfIcon fontSize="inherit" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="שלח הודעת חוב" arrow>
                            <IconButton
                                size="small"
                                color="warning"
                                onClick={() => handleSendDebtNotice(row.original)}
                            >
                                <SendIcon fontSize="inherit" />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="מחיקה" arrow>
                            <IconButton
                                size="small"
                                color="error"
                                onClick={() => handleDelete(row.original.id)}
                            >
                                <DeleteIcon fontSize="inherit" />
                            </IconButton>
                        </Tooltip>
                    </Box>
                ),
            }, 
            {
                id: 'hasPaymentMethod',
                header: 'קיים אמצעי תשלום',
                accessorFn: row =>
                    priorityData.some(p => String(p.placeId) === String(row.placeId)) ? 1 : 0,
                enableSorting: true,
                sortingFn: 'basic',
                Cell: ({ cell, row }) => {
                    const has = cell.getValue() === 1;
                    if (has) {
                        return (
                            <CheckCircleIcon
                                sx={{ color: 'success.main', fontSize: 22 }}
                                titleAccess="יש אמצעי תשלום"
                            />
                        );
                    }
                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                            <HighlightOffIcon
                                sx={{ color: 'error.main', fontSize: 22 }}
                                titleAccess="אין אמצעי תשלום"
                            />
                            <Tooltip title="הוספת אמצעי תשלום">
                                <IconButton
                                    size="small"
                                    color="primary"
                                    onClick={() => handleAddPaymentMethod(row.original)}
                                    sx={{ p: 0.5 }}
                                >
                                    <AddCircleOutlineIcon fontSize="inherit" />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    );
                },
            },
            {
                accessorKey: 'clientNum',
                header: 'מספר לקוח',
                Cell: ({ cell }) => <CopyableCell value={cell.getValue()} />,
            },
            {
                accessorKey: 'companyName',
                header: 'חברה',
                Cell: ({ cell }) => <CopyableCell value={cell.getValue()} />,
            },
            {
                accessorKey: 'pangoCommissionPercentage',
                header: 'אחוזי פנגו',
                Cell: ({ cell }) =>
                    // cell.getValue() is 0–1, so *100 for display
                    `${(cell.getValue() * 100).toFixed(2)}%`,
            },
            {
                accessorKey: 'celloCommissionPercentage',
                header: 'אחוזי סלו',
                Cell: ({ cell }) =>
                    `${(cell.getValue() * 100).toFixed(2)}%`,
            },
            {
                accessorKey: 'ccardCommissionPercentage',
                header: 'אחוזי אשראי',
                Cell: ({ cell }) =>
                    `${(cell.getValue() * 100).toFixed(2)}%`,
            },
            { accessorKey: 'stationsNum', header: 'Stations №' },
            {
                accessorKey: 'monthlyDigitalPrice',
                header: 'מחיר דיגיטל',
                Cell: ({ cell }) =>
                    cell.getValue() != null
                        ? `${cell.getValue().toLocaleString()} ₪`
                        : '—',
            },
            {
                accessorKey: 'monthlyTerminalPrice',
                header: 'מחיר טרמינל',
                Cell: ({ cell }) =>
                    cell.getValue() != null
                        ? `${cell.getValue().toLocaleString()} ₪`
                        : '—',
            },
            {
                accessorKey: 'DCODE',
                header: 'אתר',
            },
            {
                accessorKey: 'contractType',
                header: 'סוג חוזה',
                Cell: ({ cell }) => CONTRACT_TYPES[cell.getValue()] || '—',

            },
            { accessorKey: 'contractStartDate', header: 'תאריך תחילת החוזה' },
            { accessorKey: 'contractEndDate', header: 'תאריך סיום החוזה' },
            { accessorKey: 'contractNotActive', header: 'חוזה לא פעיל', Cell: ({ cell }) => cell.getValue() ? "✔" : "✘" },
            { accessorKey: 'notActiveFrom', header: 'תאריך ממנו החוזה לא פעיל' },
            {
                accessorKey: 'pay_condition',
                header: 'תנאי תשלום',
                size: 120,
                Cell: ({ cell }) => cell.getValue() || DEFAULT_PAY_CONDITION,
            },
        ], [priorityData]);


    const priorityColumns = useMemo(() => [
        { accessorKey: "placeId", header: "מזהה חניון" },
        { accessorKey: "clientNumber", header: "מס לקוח" },
        { accessorKey: "clientName", header: "שם לקוח" },
        { accessorKey: "placeName",  header: "שם חניון" },
        { accessorKey: "email",      header: "אימייל - איש קשר" },
        { accessorKey: "phone",      header: "איש קשר - נייד" },
        {
            accessorKey: "access",
            header: "האם קיימת הרשאה",
            Cell: ({ cell, row }) => {
                const hasAccess = !!cell.getValue();
                if (hasAccess) return "✔";
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <span>✘</span>
                        <Button
                            variant="contained"
                            color="warning"
                            size="small"
                            startIcon={<NotificationsActiveOutlinedIcon />}
                            onClick={() => openNotify(row.original)}
                            sx={{
                                borderRadius: 999,
                                textTransform: 'none',
                                fontWeight: 600,
                                color: textColor,
                                backgroundColor: "red",
                                px: 1.5,
                                py: 0.5,
                                boxShadow: 'none',
                                '&:hover': { boxShadow: 'none', backgroundColor: paperBg },
                            }}
                        >
                            שליחת התראה
                        </Button>
                               <Button
                                 variant="outlined"
                                 color="warning"
                                 size="small"
                                 startIcon={<RestartAltIcon />}
                                 onClick={() => openReset(row.original)}
                                 sx={{
                                   textTransform: 'none',
                                  fontWeight: 600,
                                   px: 1.5, py: 0.5,
                                 }}
                               >
                                 איפוס התראה
                              </Button>
                    </Box>
                );
            },
        },
        { accessorKey: "accessLimit",       header: "תקרת הרשאה" },
        { accessorKey: "accessLastDate",    header: "מועד פקיעת הרשאה" },
        { accessorKey: "accountNumber",     header: "מספר חשבון" },
        { accessorKey: "bankNumber",        header: "מספר בנק" },
        { accessorKey: "bankName",          header: "שם בנק" },
        { accessorKey: "companyNumber",     header: "ח.פ" },
        { accessorKey: "branchNum",         header: "סניף" },
        { accessorKey: "accessGrantDate",   header: "תאריך מתן הרשאה באישור מאיר" },
        { accessorKey: "sentFirstRequest",  header: "שלב 1-האם נשלחה בקשה ראשונה-וואטסאפ" },
        { accessorKey: "dateSentFirstRequest",  header: "תאריך שליחת התראה 1", Cell: ({ cell }) => toGMT3DateOnly(cell.getValue()) || '' },
        { accessorKey: "disconnectedCloud", header: "האם בוצע ניתוק יזום של ענן/ יוזרים" },
        { accessorKey: "sentRequest",       header: "שלב 2 - האם נשלח בקשה שניה ( מייל - לאחר 48 שעות)" },
        { accessorKey: "dateSentSecondRequest",  header: "תאריך שליחת התראה 2" , Cell: ({ cell }) => toGMT3DateOnly(cell.getValue()) || '' },
        { accessorKey: "needsFullDisconnection", header: "שלב 3 - האם נדרש ניתוק מלא" },
        { accessorKey: "dateSentThirdRequest",  header: "תאריך שליחת התראה 3" , Cell: ({ cell }) => toGMT3DateOnly(cell.getValue()) || '' },
        { accessorKey: "clientNotes",       header: "הערות לקוח" },
        { accessorKey: "clientHandle",      header: "נסגר טיפול בלקוח", Cell: ({ cell }) => cell.getValue() ? "✔" : "✘" },
        {
            accessorKey: 'attachments',
            header: 'קבצים',
            enableEditing: true,         // <-- allow it to show up in the edit modal
            size: 200,

            // how it looks in the table body
            Cell: ({ cell }) => (
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    {cell.getValue()?.map((att, i) => (
                        <React.Fragment key={i}>
                            {renderAttachmentPreview(att, i)}
                        </React.Fragment>
                    ))}
                </Box>
            ),

            // how it looks *inside* the MRT edit modal
            Edit: ({ row, table }) => {
                // grab the current attachments from MRT's editing values
                const attachments = row.getValue('attachments') || [];

                return (
                    <Box>
                        {/* file picker in edit‐mode */}
                        <Button variant="outlined" component="label" sx={{ mb: 1 }}>
                            בחירת קבצים
                            <input
                                type="file"
                                hidden
                                multiple
                                onChange={e => {
                                    // push into row.values.attachments
                                    const picked = Array.from(e.target.files);
                                    // processAttachment & trimmed logic remains the same…
                                    processAttachmentBatch(picked).then(trimmed => {
                                        table.setEditingRow({
                                            ...table.getState().editingRow,
                                            values: {
                                                ...table.getState().editingRow.values,
                                                attachments: [...attachments, ...trimmed],
                                            },
                                        });
                                    });
                                }}
                            />
                        </Button>

                        {/* previews with remove buttons */}
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            {attachments.map((att, idx) => (
                                <Box key={idx} sx={{ position: 'relative' }}>
                                    {att.previewUrl?.startsWith('data:') ? (
                                        <img
                                            src={att.previewUrl}
                                            style={{ width: 80, height: 80, objectFit: 'cover' }}
                                        />
                                    ) : (
                                        renderAttachmentPreview(att, idx)
                                    )}
                                    <IconButton
                                        size="small"
                                        onClick={() => {
                                            const next = [...attachments];
                                            next.splice(idx, 1);
                                            table.setEditingRow({
                                                ...table.getState().editingRow,
                                                values: {
                                                    ...table.getState().editingRow.values,
                                                    attachments: next,
                                                },
                                            });
                                        }}
                                        sx={{
                                            position: 'absolute',
                                            top: -6,
                                            right: -6,
                                            backgroundColor: 'rgba(255,255,255,0.8)',
                                        }}
                                    >
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                );
            },
        },
    ], []);
        // {
        //     accessorKey: "attachments",
        //     header: "Preview",
        //     size:    40,
        //
        //     Cell: ({ row,cell }) =>
        //          (
        //             <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, maxHeight: 120, overflowY: "auto" }}>
        //                 {cell.getValue()?.map((att, i) => (
        //                     <React.Fragment key={i}>{renderAttachmentPreview(att, i)}</React.Fragment>
        //                 ))}
        //             </Box>
        //         ),
        // },


  const handleTabChange = (_, newValue) => setTabIndex(newValue);

     // Load logs on first time the Logs tab is opened
         useEffect(() => {
               if (tabIndex === 4) {
                     fetchFinanceLogs(logsPagination);
                   }
                 }, [tabIndex]);

         // When user paginates while on Logs tab, refetch
             useEffect(() => {
                   if (tabIndex === 4) {
                         fetchFinanceLogs(logsPagination);
                       }
                     }, [logsPagination.pageIndex, logsPagination.pageSize]);

  const handleOpenAdd = () => {
    setForm({
      placeId: "",
      placeName: "",
      clientNum: 0,
      companyName: "",
      pangoCommissionPercentage: 0,
      celloCommissionPercentage: 0,
      ccardCommissionPercentage: 0,
      stationsNum: 0,
      monthlyDigitalPrice: 0, // ← new
      monthlyTerminalPrice: 0, // ← new
      contractType: 1, // default to 1
      priorityType: ["חנייה"],
      priorityEmails: {
        "חנה כחולה": "abc@example.com",
      },
    });
    setOriginalPlaceId(null);
    setErrorMsg("");
    setAddOpen(true);
  };
  const handleCloseAdd = () => setAddOpen(false);

  const handleEdit = (row) => {
    setForm({
      ...row,
      pangoCommissionPercentage: parseFloat((row.pangoCommissionPercentage * 100).toFixed(2)),
      celloCommissionPercentage: parseFloat((row.celloCommissionPercentage * 100).toFixed(2)),
      ccardCommissionPercentage: parseFloat((row.ccardCommissionPercentage * 100).toFixed(2)),
      monthlyDigitalPrice: row.monthlyDigitalPrice,
      monthlyTerminalPrice: row.monthlyTerminalPrice,
      contractType: row.contractType,
      priorityType: row.priorityType,
        attachments: row.attachments || [],
        newAttachments: [],
        pay_condition: row.pay_condition || DEFAULT_PAY_CONDITION,
    });
    setOriginalPlaceId(row.placeId);
    setEditOpen(true);
  };

  const handleCloseEdit = () => setEditOpen(false);

    const handleChange = (field) => (e) => {
        const { type, value, checked } = e.target;
        let val;
        if (type === 'checkbox') {
            val = checked;
        } else if (field.includes('Percentage')) {
            val = parseFloat(value);
        } else if (['clientNum','stationsNum'].includes(field)) {
            val = parseInt(value, 10);
        } else {
            val = value;
        }
        setForm(prev => ({
            ...prev,
            [field]: val,
        }));
    };

  const validateForm = () => {
    const {
      placeId,
      placeName,
      pangoCommissionPercentage,
      celloCommissionPercentage,
      ccardCommissionPercentage,
    } = form;
    return (
      placeId?.trim() &&
      placeName?.trim() &&
      [pangoCommissionPercentage, celloCommissionPercentage, ccardCommissionPercentage].every(
        (p) => p >= 0 && p <= 100
      )
    );
  };

  // const handleSubmit = async (isEdit = false) => {
  //   setErrorMsg("");
  //   if (!validateForm()) return;
  //    if (isDuplicateId(form.placeId)) {
  //     setErrorMsg("Place already exists.");
  //     return;
  //   }

  //   const url = isEdit
  //     ? "https://blue-parking-invite.bluept.dev/api/update-place-comissions"
  //     : "https://blue-parking-invite.bluept.dev/api/add-place-comissions";
  //   const method = isEdit ? "PUT" : "POST";
  //   const payload = {
  //     ...form,
  //     pangoCommissionPercentage: form.pangoCommissionPercentage / 100,
  //     celloCommissionPercentage: form.celloCommissionPercentage / 100,
  //     ccardCommissionPercentage: form.ccardCommissionPercentage / 100,
  //   };
  //   setSaving(true);
  //   try {
  //     const resp = await fetch(url, {
  //       method,
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(payload),
  //     });
  //     if (!resp.ok) throw new Error(resp.statusText);

  //     // refresh
  //     const res2 = await fetch("https://blue-parking-invite.bluept.dev/api/get-place-comissions");
  //     const json2 = await res2.json();
  //     setData(json2 || []);

  //     // success feedback
  //     setSnackbar({
  //       open: true,
  //       message: isEdit ? "Updated successfully" : "Added successfully",
  //       severity: "success",
  //     });

  //     // close modal
  //     isEdit ? setEditOpen(false) : setAddOpen(false);
  //   } catch (e) {
  //     console.error(isEdit ? "Update failed" : "Add failed", e);
  //     setSnackbar({
  //       open: true,
  //       message: isEdit ? "Update failed" : "Add failed",
  //       severity: "error",
  //     });
  //   } finally {
  //     setSaving(false);
  //   }
  // };

    async function uploadNewFiles(newAttachments) {
        if (!newAttachments?.length) return [];

        // 1) build the presign request payload
        const fileRequests = newAttachments.map(f => ({
            fileName: f.name,
            fileType: f.type,
        }));

        // 2) get presigned URLs from your backend
        const presignResp = await fetch(
            "https://blue-parking-invite.bluept.dev/api/get-presigned-urls",
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ files: fileRequests }),
            }
        );
        const { presignedUrls } = await presignResp.json();

        // 3) upload each file
        const uploaded = [];
        for (let i = 0; i < newAttachments.length; i++) {
            const fileObj = newAttachments[i];
            const { url, fields } = presignedUrls[i];

            const formData = new FormData();
            Object.entries(fields).forEach(([k, v]) => formData.append(k, v));
            formData.append("file", fileObj.file);

            const uploadResp = await fetch(url, { method: "POST", body: formData });
            if (!uploadResp.ok) {
                console.error("Upload failed for", fileObj.name);
                continue;
            }

            // build the public URL however your backend expects it
            const fileUrl = `${url}${fields.key}`;
            uploaded.push({ name: fileObj.name, type: fileObj.type, url: fileUrl });
        }

        return uploaded;
    }



  const handleSubmit = async (isEdit = false, debugOnly = false) => {
    setErrorMsg("");
    if (!validateForm()) return;

    // if (isDuplicateId(form.placeId)) {
    //   setErrorMsg("Place already exists.");
    //   return;
    // }

      let uploaded = [];
      try {
          uploaded = await uploadNewFiles(form.newAttachments || []);
      } catch (e) {
          console.error('Upload failed', e);
          setSnackbar({ open:true, severity:'error', message:'העלאת קבצים נכשלה' });
          return;
      }

      // 2) merge with existing
      const attachments = [
          ...(form.attachments || []),
          ...uploaded, // each item: { name, type, url }
      ];

    // ✅ סינון קפדני של רשומות לא חוקיות
    const priorityRecords = companies
      .filter((company) => typeof company === "string" && company.trim() !== "")
      .map((company) => {
        const isPriority = !!form.priorityType?.includes(company);
        const sendEmail = !!form.sendEmail?.includes(company);
        const email = form.priorityEmails?.[company] || null;
        return {
          companyName: company,
          isPriority,
          sendEmail,
          email: sendEmail ? email : null,
        };
      })
      .filter((rec) => rec.companyName && typeof rec.companyName === "string");

    // 🧪 דיבוג: בדוק שאין רשומות בעייתיות
    priorityRecords.forEach((rec, i) => {
      if (!rec.companyName || typeof rec.companyName !== "string") {
        console.warn(`❗ Invalid priority record at index ${i}:`, rec);
      }
    });




        const url = isEdit
            ? 'https://blue-parking-invite.bluept.dev/api/update-place-comissions'
            : 'https://blue-parking-invite.bluept.dev/api/add-place-comissions';
        const method = isEdit ? 'PUT' : 'POST';
        const payload = {
            ...form,
            pangoCommissionPercentage:  form.pangoCommissionPercentage  / 100,
            celloCommissionPercentage:  form.celloCommissionPercentage  / 100,
            ccardCommissionPercentage:  form.ccardCommissionPercentage  / 100,
            originalPlaceId,
            attachments,
            pay_condition: form.pay_condition || DEFAULT_PAY_CONDITION,
            userEmail
        };
        setSaving(true);
        try {
            const resp = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            if (!resp.ok) throw new Error(resp.statusText);

      const res2 = await fetch("https://blue-parking-invite.bluept.dev/api/get-place-comissions");
      const json2 = await res2.json();
      setData(json2 || []);

      setSnackbar({
        open: true,
        message: isEdit ? "עודכן בהצלחה" : "התווסף בהצלחה",
        severity: "success",
      });

      isEdit ? setEditOpen(false) : setAddOpen(false);
    } catch (e) {
      console.error(isEdit ? "Update failed" : "Add failed", e);
      setSnackbar({
        open: true,
        message: isEdit ? "שגיאה בעדכון" : "שגיאה בהוספה",
        severity: "error",
      });
    } finally {
      setSaving(false);
    }
  };

    const makeImageThumb = (file, max = 200) => new Promise((resolve) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
            const scale = Math.min(max / img.width, max / img.height);
            const cvs   = document.createElement("canvas");
            cvs.width   = Math.round(img.width  * scale);
            cvs.height  = Math.round(img.height * scale);
            cvs.getContext("2d").drawImage(img, 0, 0, cvs.width, cvs.height);
            cvs.toBlob((blob) => {
                resolve(new File([blob], `thumb-${file.name.replace(/\.[^.]+$/, '.jpg')}`, {
                    type: "image/jpeg"
                }));
            }, "image/jpeg", 0.8);
        };
    });
    const guessIcon = (mime) => {
        if (mime.includes("spreadsheet"))           return "xlsx";
        if (mime === "application/vnd.ms-excel")    return "xls";
        if (mime === "application/pdf")             return "pdf";
        if (mime.includes("zip"))                   return "zip";
        return "generic";
    };
    async function processAttachmentBatch(files) {
        // 1) run your existing processAttachment on each file in parallel
        const processed = await Promise.all(files.map(processAttachment));

        // 2) map to the same “trimmed” shape you do in handleFileChange
        return processed.map(({ original, thumbnail, icon }) => ({
            file:       original,
            thumbFile:  thumbnail ?? null,
            iconName:   icon      ?? null,
            name:       original.name,
            type:       original.type,
            previewUrl: URL.createObjectURL(thumbnail ?? original),
        }));
    }

    async function processAttachment(file) {
        const isTS = file.type === "video/vnd.dlna.mpeg-tts"
            || /\.ts$/i.test(file.name)

        if (file.type.startsWith("image/")) {
            const thumb = await makeImageThumb(file, 200);
            return { original: file, thumbnail: thumb };
        }

        // only thumbnail “real” videos browsers support
        if (!isTS && file.type.startsWith("video/")) {
            const thumb = await makeVideoThumb(file, 200);
            return { original: file, thumbnail: thumb };
        }

        // fallback for TS or any other unknown type
        return { original: file, icon: guessIcon(file.type) };
    }



    const handleFileChange = async (e, isNewReceipt = false) => {
        e.preventDefault();
        const picked = Array.from(e.target.files);
        const processed = await Promise.all(picked.map(processAttachment));
        const trimmed = processed.map(({ original, thumbnail, icon }) => ({
            file:       original,
            thumbFile:  thumbnail ?? null,
            iconName:   icon      ?? null,
            name:       original.name,
            type:       original.type,
            previewUrl: URL.createObjectURL(thumbnail ?? original),
        }));

        if (priorityForm) {
            // 🎯 we’re in the “edit priority” modal
            setPriorityForm(prev => ({
                ...prev,
                newAttachments: [...(prev.newAttachments||[]), ...trimmed],
            }));
        } else if (isNewReceipt) {
            // your existing create flow
            setNewReceipt(prev => ({
                ...prev,
                newAttachments: [...(prev.newAttachments||[]), ...trimmed],
            }));
        } else {
            // your create-modal attachments
            setNewReceipt(prev => ({
                ...prev,
                attachments: prev.attachments
                    ? [...prev.attachments, ...trimmed]
                    : trimmed,
            }));
        }
    };



    useEffect(() => {
    if (addOpen) {
      setForm(form); // ← העתק מה־useState ההתחלתי
      setErrorMsg("");
    }
  }, [addOpen]);

  const handleSnackbarClose = () => {
    setSnackbar((s) => ({ ...s, open: false }));
  };

    const handleRemoveAttachment = (index, isNew = false) => {
        setNewReceipt((prev) => {
            // Decide whether to remove from existing attachments or new attachments
            if (isNew) {
                const updatedNew = prev.newAttachments ? [...prev.newAttachments] : [];
                updatedNew.splice(index, 1);
                return { ...prev, newAttachments: updatedNew };
            } else {
                const updatedExisting = prev.attachments ? [...prev.attachments] : [];
                updatedExisting.splice(index, 1);
                return { ...prev, attachments: updatedExisting };
            }
        });
    };

  const handleAddEventChangePlace = (pname, pid) => {
    // const { name, value } = e.target;
    // console.log('name: ', name, "value: ", value);
    setForm((prev) => ({
      ...prev,
      ["placeName"]: pname,
      ["placeId"]: pid,
    }));
  };

  const formatDisplayDate = (d) => (d ? new Date(d).toLocaleDateString('he-IL') : "");

    const contractTypeCounts = data.reduce((acc, item) => {
        const type = item.contractType;
        if (CONTRACT_TYPES[type]) {
            acc[type] = (acc[type] || 0) + 1;
        }
        return acc;
    }, {});


    return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box p={3} sx={{ backgroundColor: pageBackground, color: textColor, minHeight: "100vh" }}>
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Typography variant="h4">עמלות לקוחות
          </Typography>
            { tabIndex === 0 && <Button variant="contained" startIcon={<AddIcon />} onClick={handleOpenAdd}>
            הוסף
          </Button>}

            {tabIndex === 1 && (
                // <Box mb={2} display="flex" justifyContent="flex-end">
                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={() => {
                            setNewReceipt(initialReceipt);
                            setCreateOpen(true);
                        }}
                    >
                        הוסף
                    </Button>
                // </Box>
            )}
        </Box>
        <Paper square sx={{ backgroundColor: paperBg }}>
          <Tabs value={tabIndex} onChange={handleTabChange} indicatorColor="primary">
            <Tab label="עמלות" />
              <Tab label="אמצעי תשלום" />
              <Tab label="נתח הכנסות" />
            <Tab label="תשלום חודשי" />
              <Tab label="לוג" />
          </Tabs>
        </Paper>

          {tabIndex === 0 && (
            <> 
                <Box
                display="flex"
                flexWrap="wrap"
                justifyContent="center"
                alignItems="center"
                gap={2}
                my={1}
                p={2}
                sx={{
                    
                    borderRadius: 2,
                    boxShadow: 1,
                }}
                >
                <TextField
                    label="From"
                    type="date"
                    size="small"
                    value={contractFrom}
                    onChange={(e) => setContractFrom(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    sx={{ minWidth: 180 }}
                />

                <TextField
                    label="To"
                    type="date"
                    size="small"
                    value={contractTo}
                    onChange={(e) => setContractTo(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    sx={{ minWidth: 180 }}
                />

                <Button
                    variant="contained"
                    color="primary"
                    size="medium"
                    onClick={async () => {
                    if (!contractFrom || !contractTo) {
                        setSnackbar({ open: true, severity: "warning", message: "בחר טווח תאריכים" });
                        return;
                    }

                    const fromDate = new Date(contractFrom);
                    const toDate = new Date(contractTo);

                    if (toDate < fromDate) {
                        setSnackbar({ open: true, severity: "error", message: "תאריך סיום לא יכול להיות מוקדם מתאריך התחלה" });
                        return;
                    }

                    try {
                        setRevenuesLoading(true);
                        const fromEpoch = Math.floor(new Date(contractFrom + "T00:00:00").getTime() / 1000);
                        const toEpoch = Math.floor(new Date(contractTo + "T23:59:59").getTime() / 1000);
                        const res = await fetch(`https://blue-parking-invite.bluept.dev/api/revenues?from=${fromEpoch}&to=${toEpoch}`);
                        if (!res.ok) throw new Error(`HTTP ${res.status}`);
                        const json = await res.json();
                        setRevenues(Array.isArray(json) ? json : []);
                    } catch (err) {
                        console.error("fetch revenues failed", err);
                        setRevenues([]);
                        setSnackbar({ open: true, severity: "error", message: "Fetch revenues failed" });
                    } finally {
                        setRevenuesLoading(false);
                    }
                    }}
                >
                    Calculate
                </Button>

                <Button
                    variant="contained"
                    color="secondary"
                    size="medium"
                    onClick={() => {
                        setContractFrom("");
                        setContractTo("");
                        setRevenues(null);
                    }}
                >
                    Clear
                </Button>
                </Box>

                {/* Date range / current month display */}
                <Box>
                    <Typography
                        textAlign="center"
                        variant="subtitle2"
                        sx={{
                        color: textColor,
                        fontWeight: 500,
                        my: 2
                        }}
                    >
                        {contractFrom && contractTo && revenues
                        ? `Selected range: ${formatDisplayDate(contractFrom)} — ${formatDisplayDate(contractTo)}`
                        : `Current month: ${new Date().toLocaleString("default", { month: "long", year: "numeric" })}`}
                    </Typography>
                </Box>
                <Grid container spacing={2}>
                    {revenuesLoading ? (
                        <Box  sx={{ color: textColor}} display="flex" justifyContent="center" alignItems="center" width="100%" py={6}>
                            <CircularProgress size={120} thickness={3} />
                        </Box>
                    ) : (
                        contractSummary.map((item) => (
                            <Grid item xs={12} sm={12} md={4} key={item.contractType}>
                                <Card
                                    sx={{
                                    borderRadius: 5,
                                    boxShadow: 5,
                                    mb: 2,
                                    backgroundColor: pageBackground,
                                    }}
                                >
                                    <CardContent sx={{ color: textColor }}>
                                    <Typography variant="h6" gutterBottom align="center">
                                        {item.label}
                                    </Typography>
                                    <Divider sx={{ my: 1 }} />
                                    <Typography variant="body2" sx={{ fontSize: "0.9rem" }}>
                                        {/* <strong>Contracts:</strong> {String(item.count).toLocaleString()} */}
                                         <strong>Contracts:</strong> {item.noData ? "N/A" : String(item.count).toLocaleString()}
                                    </Typography>
                                    <Typography variant="body2" sx={{ fontSize: "0.9rem" }}>
                                        <strong>Pango:</strong> {fmtILS(item.pango)}
                                        <span style={{ color: "gray" }}>
                                        {" "} | <strong>Commission:</strong> {fmtILS(item.pangoCommission)}
                                        </span>
                                    </Typography>
                                    <Typography variant="body2" sx={{ fontSize: "0.9rem" }}>
                                        <strong>Cello:</strong> {fmtILS(item.cello)}
                                        <span style={{ color: "gray" }}>
                                        {" "} | <strong>Commission:</strong> {fmtILS(item.celloCommission)}
                                        </span>
                                    </Typography>
                                    <Typography variant="body2" sx={{ fontSize: "0.9rem" }}>
                                        <strong>Credit:</strong> {fmtILS(item.credit)}
                                        <span style={{ color: "gray" }}>
                                        {" "} | <strong>Commission:</strong> {fmtILS(item.ccardCommission)}
                                        </span>
                                    </Typography>
                                    <Divider sx={{ my: 1 }} />
                                    <Typography variant="body2" sx={{ fontSize: "0.9rem" }}>
                                        <strong>Total:</strong> {fmtILS(item.total)}
                                    </Typography>
                                    <Typography variant="body2" sx={{ fontSize: "0.9rem" }}>
                                        <strong>Commission Total:</strong> {fmtILS(item.commissionTotal)}
                                    </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))
                    )}
                </Grid> 
            </>  
              ) 
          }

          {tabIndex === 1 && (
              <>
                  <Button
                      variant="contained"
                      sx={{backgroundColor: "#008000",
                          "&:hover": {
                              backgroundColor: "#008000",   // same green on hover
                          },
                      }}
                      size="small"
                      onClick={handleExport}
                  >
                      ייצוא לקובץ אקסל
                  </Button>
              <Stack
                  direction="row"
                  spacing={4}
                  alignItems="center"
                  mb={2}
              >
                  {[
                      ["לקוחות",           priorityData.length],
                      ["הרשאות", priorityData.filter((p => p.access)).length],
                  ].map(([label, value]) => (
                      <Box key={label} textAlign="center">
                          <Typography variant="caption">
                              {label}
                          </Typography>
                          <Typography variant="h6">{value}</Typography>
                      </Box>
                  ))}
              </Stack></>)
          }

        {tabIndex === 0 && (
          <MaterialReactTable
            columns={columns}
            data={data}
            globalFilterFn="contains"
            autoResetPageIndex={false}
            state={{ isLoading: loading }}
            muiTablePaperProps={{ sx: { backgroundColor: paperBg } }}
            muiTableHeadCellProps={{
              sx: {
                backgroundColor: darkMode ? "#27293d" : "#0098CF",
                color: "white",
                fontWeight: "bold",
              },
            }}
            muiTableBodyCellProps={{ sx: { color: textColor } }}
            muiTableBodyRowProps={({ row }) => ({
              sx: {
                // highlight the parent row when it's expanded
                backgroundColor: row.getIsExpanded()
                  ? (theme) => theme.palette.action.hover
                  : undefined,
                // give all child rows a very light tinted background
                ...(row.depth > 0 && {
                  backgroundColor: (theme) => theme.palette.grey[50],
                }),
                // optional: add a left border for children
                ...(row.depth > 0 && {
                  borderLeft: (theme) => `4px solid ${theme.palette.primary.light}`,
                }),
              },
            })}
            muiBottomToolbarProps={{
              sx: {
                backgroundColor: darkMode ? "#1e293b" : "#fff",
                color: darkMode ? "#fff" : "#1e293b",
                ".MuiFormLabel-root": {
                  color: darkMode ? "#fff" : "#1e293b",
                },
                ".MuiSelect-icon": {
                  color: darkMode ? "#fff" : "#1e293b",
                },
                ".MuiSelect-select": {
                  color: darkMode ? "#fff" : "#1e293b",
                },
                ".MuiBox-root.MuiButtonBase-root": {
                  color: darkMode ? "#fff" : "#1e293b",
                },
                ".MuiSvgIcon-root": {
                  color: darkMode ? "#fff" : "#1e293b",
                },
                "& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root": {
                  // pick a dimmer color for disabled icons
                  color: darkMode ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.3)",
                },
              },
            }}
            muiTopToolbarProps={{
              sx: {
                backgroundColor: darkMode ? "#1e293b" : "#fff",
                color: "#fff",
                ".MuiSvgIcon-root": {
                  color: darkMode ? "#fff" : "#1e293b",
                },
                // ".Mui-TableHeadCell": {
                //     color: darkMode ? '#fff' : '#1e293b',
                // },
                ".MuiTableSortLabel-iconDirectionAsc": {
                  color: darkMode ? "#fff" : "#1e293b",
                },
                "& .MuiInputBase-input": {
                  color: darkMode ? "#fff" : "#1e293b",
                },
              },
            }}
            muiTableBodyCellProps={({ row }) => ({
              sx: {
                backgroundColor: darkMode ? "#1e293b" : "#ffffff",
                color: darkMode ? "#ffffff" : "#000",
                ".MuiSvgIcon-root": {
                  color: darkMode ? "#ffffff" : "#000",
                },
                maxWidth: "80px",
              },
            })}

            muiTableHeadCellProps={{
              sx: {
                backgroundColor: darkMode ? "#1e293b" : "#0098CF",
                color: "white",
                fontWeight: "bold",
                ".MuiSvgIcon-root": {
                  color: darkMode ? "#ffffff" : "#000",
                },
                ".Mui-TableHeadCell-Content-Wrapper": {
                  color: darkMode ? "#fff" : "#1e293b",
                },
                // then specifically target the sort label icon:
                "& .MuiTableSortLabel-icon": {
                  color: darkMode ? "#fff !important" : "#000 !important",
                },
                // likewise for iconDirectionAsc / iconDirectionDesc if needed
                "& .MuiTableSortLabel-iconDirectionAsc": {
                  color: darkMode ? "#fff !important" : "#000 !important",
                },
                "& .MuiTableSortLabel-iconDirectionDesc": {
                  color: darkMode ? "#fff !important" : "#000 !important",
                },
                "& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root": {
                  // pick a dimmer color for disabled icons
                  color: darkMode ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.3)",
                },
                "& .MuiInputBase-input": {
                  color: darkMode ? "#fff" : "#1e293b",
                },
              },
            }}
            muiTableHeadProps={{
              sx: {
                display: "table-header-group",
                backgroundColor: "rgb(0,0,0)",
                color: "white",
                "&.Mui-TableHeadCell-Content-Wrapper": { color: "white" },
              },
            }}
            muiTableContainerProps={{
              sx: {
                width: "100%",
                // overflowX: "auto",
                backgroundColor: "#15aff4",
                color: "white",
              },
            }}
          />
        )}

           {tabIndex === 4 && (
             <MaterialReactTable
               columns={logsColumns}
               data={logs}
               muiTopToolbarProps={{
                   sx: {
                       backgroundColor: darkMode ? "#1e293b" : "#fff",
                       color: "#fff",
                       ".MuiSvgIcon-root": {
                           color: darkMode ? "#fff" : "#1e293b",
                       },
                       // ".Mui-TableHeadCell": {
                       //     color: darkMode ? '#fff' : '#1e293b',
                       // },
                       ".MuiTableSortLabel-iconDirectionAsc": {
                           color: darkMode ? "#fff" : "#1e293b",
                       },
                       "& .MuiInputBase-input": {
                           color: darkMode ? "#fff" : "#1e293b",
                       },
                   },
               }}
               muiBottomToolbarProps={{
                   sx: {
                       backgroundColor: darkMode ? "#1e293b" : "#fff",
                       color: darkMode ? "#fff" : "#1e293b",
                       ".MuiFormLabel-root": {
                           color: darkMode ? "#fff" : "#1e293b",
                       },
                       ".MuiSelect-icon": {
                           color: darkMode ? "#fff" : "#1e293b",
                       },
                       ".MuiSelect-select": {
                           color: darkMode ? "#fff" : "#1e293b",
                       },
                       ".MuiBox-root.MuiButtonBase-root": {
                           color: darkMode ? "#fff" : "#1e293b",
                       },
                       ".MuiSvgIcon-root": {
                           color: darkMode ? "#fff" : "#1e293b",
                       },
                       "& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root": {
                           // pick a dimmer color for disabled icons
                           color: darkMode ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.3)",
                       },
                   },
               }}

               muiTableHeadCellProps={{
                   sx: {
                       backgroundColor: darkMode ? "#1e293b" : "#0098CF",
                       color: "white",
                       fontWeight: "bold",
                       ".MuiSvgIcon-root": {
                           color: darkMode ? "#ffffff" : "#000",
                       },
                       ".Mui-TableHeadCell-Content-Wrapper": {
                           color: darkMode ? "#fff" : "#1e293b",
                       },
                       // then specifically target the sort label icon:
                       "& .MuiTableSortLabel-icon": {
                           color: darkMode ? "#fff !important" : "#000 !important",
                       },
                       // likewise for iconDirectionAsc / iconDirectionDesc if needed
                       "& .MuiTableSortLabel-iconDirectionAsc": {
                           color: darkMode ? "#fff !important" : "#000 !important",
                       },
                       "& .MuiTableSortLabel-iconDirectionDesc": {
                           color: darkMode ? "#fff !important" : "#000 !important",
                       },
                       "& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root": {
                           // pick a dimmer color for disabled icons
                           color: darkMode ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.3)",
                       },
                       "& .MuiInputBase-input": {
                           color: darkMode ? "#fff" : "#1e293b",
                       },
                   },
               }}
               muiTableBodyCellProps={({ row }) => ({
                   sx: {
                       backgroundColor: darkMode ? "#1e293b" : "#ffffff",
                       color: darkMode ? "#ffffff" : "#000",
                       ".MuiSvgIcon-root": {
                           color: darkMode ? "#ffffff" : "#000",
                       },
                       maxWidth: "80px",
                   },
               })}

               muiTableHeadProps={{
                   sx: {
                       display: "table-header-group",
                       backgroundColor: "rgb(0,0,0)",
                       color: "white",
                       "&.Mui-TableHeadCell-Content-Wrapper": { color: "white" },
                   },
               }}
                 // editingMode="modal"

               muiEditRowDialogProps={{
                   PaperProps: {
                       sx: {
                           bgcolor: paperBg,
                           color: "#fff",
                           "& .MuiDialogTitle-root, & .MuiDialogContent-root, & .MuiDialogActions-root": {
                               backgroundColor: darkMode ? "#27293d" : "#0098CF",
                               color: "#fff",
                           },
                       },
                   },
               }}
               enableRowActions={false}
               enableColumnActions={false}
               enableSorting={false}          // view-only, keep it simple; add server sorting later if desired
               manualPagination                // tell MRT we page on the server
               rowCount={logsRowCount}         // total rows on server
               state={{
                 isLoading: logsLoading,
                 pagination: logsPagination,
               }}
               onPaginationChange={setLogsPagination}
               muiTablePaperProps={{ sx: { backgroundColor: paperBg } }}
             />
           )}

          {tabIndex === 1 && (
              <MaterialReactTable
                  columns={priorityColumns}
                  data={priorityData}
                  autoResetPageIndex={false}
                  globalFilterFn="contains"
                  // state={{ isLoading: loadingPriority }}
                  enableEditing   // מאפשר inline editing
                  muiTableBodyCellProps={{ sx: { color: textColor } }}
                  enableRowActions
                  displayColumnDefOptions={{
                      'mrt-row-actions': {
                          header: 'פעולות',             // <-- change header text here
                          muiTableHeadCellProps: { align: 'center' },
                          size: 90,
                      },
                  }}
                  muiTopToolbarProps={{
                      sx: {
                          backgroundColor: darkMode ? "#1e293b" : "#fff",
                          color: "#fff",
                          ".MuiSvgIcon-root": {
                              color: darkMode ? "#fff" : "#1e293b",
                          },
                          // ".Mui-TableHeadCell": {
                          //     color: darkMode ? '#fff' : '#1e293b',
                          // },
                          ".MuiTableSortLabel-iconDirectionAsc": {
                              color: darkMode ? "#fff" : "#1e293b",
                          },
                          "& .MuiInputBase-input": {
                              color: darkMode ? "#fff" : "#1e293b",
                          },
                      },
                  }}
                  muiBottomToolbarProps={{
                      sx: {
                          backgroundColor: darkMode ? "#1e293b" : "#fff",
                          color: darkMode ? "#fff" : "#1e293b",
                          ".MuiFormLabel-root": {
                              color: darkMode ? "#fff" : "#1e293b",
                          },
                          ".MuiSelect-icon": {
                              color: darkMode ? "#fff" : "#1e293b",
                          },
                          ".MuiSelect-select": {
                              color: darkMode ? "#fff" : "#1e293b",
                          },
                          ".MuiBox-root.MuiButtonBase-root": {
                              color: darkMode ? "#fff" : "#1e293b",
                          },
                          ".MuiSvgIcon-root": {
                              color: darkMode ? "#fff" : "#1e293b",
                          },
                          "& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root": {
                              // pick a dimmer color for disabled icons
                              color: darkMode ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.3)",
                          },
                      },
                  }}

                  muiTableHeadCellProps={{
                      sx: {
                          backgroundColor: darkMode ? "#1e293b" : "#0098CF",
                          color: "white",
                          fontWeight: "bold",
                          ".MuiSvgIcon-root": {
                              color: darkMode ? "#ffffff" : "#000",
                          },
                          ".Mui-TableHeadCell-Content-Wrapper": {
                              color: darkMode ? "#fff" : "#1e293b",
                          },
                          // then specifically target the sort label icon:
                          "& .MuiTableSortLabel-icon": {
                              color: darkMode ? "#fff !important" : "#000 !important",
                          },
                          // likewise for iconDirectionAsc / iconDirectionDesc if needed
                          "& .MuiTableSortLabel-iconDirectionAsc": {
                              color: darkMode ? "#fff !important" : "#000 !important",
                          },
                          "& .MuiTableSortLabel-iconDirectionDesc": {
                              color: darkMode ? "#fff !important" : "#000 !important",
                          },
                          "& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root": {
                              // pick a dimmer color for disabled icons
                              color: darkMode ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.3)",
                          },
                          "& .MuiInputBase-input": {
                              color: darkMode ? "#fff" : "#1e293b",
                          },
                      },
                  }}
                  muiTableBodyCellProps={({ row }) => ({
                      sx: {
                          backgroundColor: darkMode ? "#1e293b" : "#ffffff",
                          color: darkMode ? "#ffffff" : "#000",
                          ".MuiSvgIcon-root": {
                              color: darkMode ? "#ffffff" : "#000",
                          },
                          maxWidth: "80px",
                      },
                  })}

                  muiTableHeadProps={{
                      sx: {
                          display: "table-header-group",
                          backgroundColor: "rgb(0,0,0)",
                          color: "white",
                          "&.Mui-TableHeadCell-Content-Wrapper": { color: "white" },
                      },
                  }}
                  // editingMode="modal"

                  muiEditRowDialogProps={{
                      PaperProps: {
                          sx: {
                              bgcolor: paperBg,
                              color: "#fff",
                              "& .MuiDialogTitle-root, & .MuiDialogContent-root, & .MuiDialogActions-root": {
                                  backgroundColor: darkMode ? "#27293d" : "#0098CF",
                                  color: "#fff",
                              },
                          },
                      },
                  }}

                  // 2) text‐field styling
                  muiEditTextFieldProps={({
                                              cell,
                                              column,
                                              row,
                                              table,
                                          }) => ({
                      // any valid TextFieldProps here…
                      variant: "standard",
                      fullWidth: true,
                      sx: {
                          // label
                          "& .MuiFormLabel-root": { color: "#bbb" },
                          // input text
                          "& .MuiInputBase-input": { color: "#fff" },
                          // underline / outline, etc.
                          "& .MuiInput-underline:before": { borderBottomColor: "#555" },
                          "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                              borderBottomColor: "#888",
                          },
                      },
                  })}


                  renderRowActions={({ row }) => (
                      <Box sx={{ display: 'flex', gap: '0.01rem' }}>

                      <IconButton onClick={() => handleOpenPriorityEdit(row.original)}>
                               <EditIcon />
                             </IconButton>

                          <IconButton
                              color="error"
                              onClick={() => handleDeleteRow(row)}
                              sx={{
                                  color: (theme) => theme.palette.error.main,
                                  opacity: 1,                  // override the 0.54 default
                                  "&:hover": { opacity: 0.8 }, // if you like
                              }}
                          >
                              <DeleteIcon />
                          </IconButton>
                        </Box>

                      )}
                  muiEditCellTextFieldProps={{
                      sx: {
                          "& .MuiInputBase-root": { color: "#fff" },
                          "& .MuiInputBase-input": { color: "#fff" },
                          "& .MuiFormLabel-root": { color: "#fff" },
                      },
                  }}

                  onEditingRowSave={async ({ exitEditingMode, row, values }) => {
                      try {
                          await fetch(`https://blue-parking-invite.bluept.dev/api/priority-receipts/${row.original.id}`, {
                              method: "PUT",
                              headers: { "Content-Type": "application/json" },
                              body: JSON.stringify(values),
                          });
                          // עדכון מקומי של השורה
                          setPriorityData((prev) =>
                              prev.map((r) =>
                                  r.placeId === row.original.placeId ? { ...r, ...values } : r
                              )
                          );
                          exitEditingMode(); // סוגר את מצב ה‑edit
                          setSnackbar({ open: true, message: "Saved!", severity: "success" });
                      } catch {
                          setSnackbar({ open: true, message: "Save failed", severity: "error" });
                      }
                  }}

                  muiTablePaperProps={{ sx: { backgroundColor: paperBg } }}
              />
          )}
          <Modal open={payCondConfirm.open} onClose={() => setPayCondConfirm({ open:false, pendingValue:null })}>
              <Box sx={{
                  position:'absolute', top:'50%', left:'50%', transform:'translate(-50%,-50%)',
                  bgcolor: paperBg, color:'#fff', p:3, borderRadius:2, width: 'min(520px, 92vw)'
              }}>
                  <Typography sx={{ mb:2, fontWeight:700 }}>
                      שים לב! שינוי ערך תנאי תשלום דורש אישור מנכ״ל.
                  </Typography>
                  <Box display="flex" justifyContent="flex-end" gap={1}>
                      <Button onClick={() => setPayCondConfirm({ open:false, pendingValue:null })}>בטל</Button>
                      <Button variant="contained" onClick={() => {
                          setForm(prev => ({ ...prev, pay_condition: payCondConfirm.pendingValue }));
                          setPayCondConfirm({ open:false, pendingValue:null });
                          // (אופציונלי) רשום לוג פעולה בשרת אם קיים endpoint מתאים
                          // await fetch('/finance/logs', { method:'POST', body: JSON.stringify({ action:'PAY_CONDITION_CHANGED', ... }) })
                      }}>אוקיי</Button>
                  </Box>
              </Box>
          </Modal>
          <Modal open={notifyOpen} onClose={closeNotify}>
              <Box
                  sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      bgcolor: paperBg,
                      color: textColor,
                      p: 3,
                      borderRadius: 3,
                      width: '95%',
                      maxWidth: 520,
                      boxShadow: 24,
                      direction: 'rtl',
                  }}
              >
                  <Typography variant="h6" mb={1.5}>אישור שליחת התראה</Typography>

                  <Typography variant="body1" mb={2}>
                      האם אתה בטוח שברצונך לשלוח {getNextAlertLabel(notifyRow)} ללקוח?
                  </Typography>

                  <Box mb={2}>
                      <FormControlLabel
                          control={
                              <Checkbox
                                  checked={notifyChannels.email}
                                  onChange={(e) => setNotifyChannels((c) => ({ ...c, email: e.target.checked }))}
                              />
                          }
                          label="שליחה במייל"
                      />
                      <FormControlLabel
                          control={
                              <Checkbox
                                  checked={notifyChannels.whatsapp}
                                  onChange={(e) => setNotifyChannels((c) => ({ ...c, whatsapp: e.target.checked }))}
                              />
                          }
                          label="שליחה בוואטסאפ"
                      />
                  </Box>

                  <Box display="flex" justifyContent="flex-end" gap={1.5}>
                      <Button variant="text" onClick={closeNotify}>בטל</Button>
                      <Button
                          variant="contained"
                          onClick={handleSendNotification}

                            disabled={!notifyChannels.email && !notifyChannels.whatsapp && notifySending}
                      >
                          שלח
                      </Button>
                  </Box>
              </Box>
          </Modal>
           <Modal open={resetOpen} onClose={closeReset}>
             <Box
               sx={{
                 position: 'absolute',
                 top: '50%', left: '50%',
                transform: 'translate(-50%, -50%)',
                 bgcolor: paperBg, color: textColor,
                 p: 3, borderRadius: 3, width: '95%', maxWidth: 520, boxShadow: 24, direction: 'rtl',
               }}
             >
               <Typography variant="h6" mb={1.5}>איפוס התראה</Typography>
               <Typography variant="body1" mb={2}>
                 בחר את ההתראה שברצונך לאפס עבור הלקוח {resetRow?.clientName || ""}.
               </Typography>

               <FormControl fullWidth sx={{ mb: 2 }}>
                 <InputLabel id="reset-select-label">בחר התראה לאיפוס</InputLabel>
                   <Select
                      multiple
                      labelId="reset-select-label"
                      label="בחר התראה לאיפוס"
                      value={resetSelected}
                      sx={{height: 40}}
                     onChange={(e) => setResetSelected(
                        typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value
                          )}
                      renderValue={(selected) => {
                        const labels = RESET_OPTIONS
                              .filter(o => selected.includes(o.value))
                          .map(o => o.label);
                        return labels.join(' , ');
                      }}
                    >
                      {RESET_OPTIONS.map(opt => (
                        <MenuItem key={opt.value} value={opt.value}>
                              <Checkbox checked={resetSelected.indexOf(opt.value) > -1} />
                              <ListItemText primary={opt.label} />
                            </MenuItem>
                      ))}
                    </Select>
               </FormControl>

               <Box display="flex" justifyContent="flex-end" gap={1.5}>
                 <Button variant="text" onClick={closeReset}>בטל</Button>
                 <Button
                  variant="contained"
                   onClick={handleResetSubmit}
                  disabled={ resetSelected.map(Number).length===0 || resetSending}
                 >
                   אפס
                </Button>
               </Box>
           </Box>
         </Modal>
          <Modal open={editPriorityOpen} onClose={handleClosePriorityEdit}>
              <Box
                  sx={{
                      position:       "absolute",
                      top:            "50%",
                      left:           "50%",
                      transform:      "translate(-50%, -50%)",
                      bgcolor:        "#1e1e2f",
                      color:          "#fff",
                      p:              3,
                      borderRadius:   3,
                      width:          "95%",
                      maxWidth:       600,
                      maxHeight:      "85vh",
                      overflowY:      "auto",
                      boxShadow:      24,
                  }}
              >
                  <Typography variant="h6" mb={2}>עריכת הרשאה</Typography>
                  {/* any validation alert here */}
                  {/* render all your text‐fields / checkboxes exactly like in createOpen,
       but bound to priorityForm, e.g.: */}


                  {[
                      { name: "placeId",               label: "מזהה חניון",                           type: "text"   },
                      { name: "clientNumber",          label: "מס לקוח",                               type: "number" },
                      { name: "clientName",            label: "שם לקוח",                              type: "text"   },
                      { name: "placeName",             label: "שם חניון",                             type: "text"   },
                      { name: "email",                 label: "אימייל - איש קשר",                     type: "email"  },
                      { name: "phone",                 label: "איש קשר - נייד",                      type: "text"   },
                      { name: "accessLimit",           label: "תקרת הרשאה",                          type: "number" },
                      { name: "accessLastDate",        label: "מועד פקיעת הרשאה",                  type: "date"   },
                      { name: "accountNumber",         label: "מספר חשבון",                          type: "number" },
                      { name: "bankNumber",            label: "מספר בנק",                            type: "number" },
                      { name: "bankName",              label: "שם בנק",                              type: "text"   },
                      { name: "companyNumber",         label: "ח.פ",                                 type: "text"   },
                      { name: "branchNum",             label: "סניף",                                type: "text"   },
                      { name: "accessGrantDate",       label: "תאריך מתן הרשאה באישור מאיר",        type: "date"   },
                      { name: "sentFirstRequest",      label: "שלב 1 – האם נשלחה בקשה ראשונה (וואטסאפ)", type: "text"   },
                      { name: "disconnectedCloud",     label: "האם בוצע ניתוק יזום של ענן/יוזרים",   type: "text"   },
                      { name: "sentRequest",           label: "שלב 2 – האם נשלחה בקשה שניה (מייל – 48 שעות)", type: "text"   },
                      { name: "needsFullDisconnection",label: "שלב 3 – האם נדרש ניתוק מלא",        type: "text"   },
                      { name: "clientNotes",           label: "הערות לקוח",                          type: "text"   },
                  ].map(({ name, label, type }) => (
                      <TextField
                          key={name}
                          fullWidth
                          label={label}
                          type={type}
                          value={priorityForm?.[name] ?? ""}
                          onChange={e => setPriorityForm(p => ({
                              ...p,
                              [name]: type === "number"
                                  ? parseInt(e.target.value, 10)
                                  : e.target.value,
                          }))}
                          margin="normal"
                      />
                  ))}

                  <FormControlLabel
                      control={
                          <Checkbox
                              checked={!!priorityForm?.access}
                              onChange={e => setPriorityForm(p => ({ ...p, access: e.target.checked }))}
                          />
                      }
                      label="האם קיימת הרשאה"
                  />
                  <FormControlLabel
                      control={
                          <Checkbox
                              checked={!!priorityForm?.clientHandle}
                              onChange={e => setPriorityForm(p => ({ ...p, clientHandle: e.target.checked }))}
                          />
                      }
                      label="נסגר טיפול בלקוח"
                  />


                  {/* file picker */}
                  <Button variant="outlined" component="label" sx={{ mt: 2 }}>
                      בחירת קבצים
                      <input
                          type="file"
                          hidden
                          multiple
                          onChange={handlePriorityFileChange}
                      />
                  </Button>

                  {/* previews of existing + new */}
                  <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 2 }}>
                      {(priorityForm?.attachments || []).map((att, i) => (
                          <Box key={`old-${i}`} sx={{ position: 'relative' }}>
                              {renderAttachmentPreview(att, i)}
                              <IconButton
                                  size="small"
                                  onClick={() => {
                                      const next = [...priorityForm.attachments];
                                      next.splice(i, 1);
                                      setPriorityForm(p => ({ ...p, attachments: next }));
                                  }}
                                  sx={{ position: 'absolute', top: -6, right: -6, backgroundColor: 'rgba(255,255,255,0.8)' }}
                              >
                                  <CloseIcon fontSize="small" />
                              </IconButton>
                          </Box>
                      ))}
                      {(priorityForm?.newAttachments || []).map((att, i) => (
                          <Box key={`new-${i}`} sx={{ position: 'relative' }}>
                              {att.type.startsWith('image/') ? (
                                  <img
                                      src={att.previewUrl}
                                      style={{ width: 80, height: 80, objectFit: 'cover' }}
                                      onClick={() => handleDownload(att.url, att.name)}
                                  />
                              ) : att.type.startsWith('video/') ? (
                                  <video
                                      src={att.previewUrl}
                                      muted
                                      preload="metadata"
                                      style={{ width: 80, height: 80, objectFit: 'cover', cursor: 'pointer' }}
                                      onClick={() => handleDownload(att.url, att.name)}
                                  />
                              ) : (
                                  <Button
                                      variant="text"
                                      color="info"
                                      onClick={() => handleDownload(att.url, att.name)}
                                  >
                                      {att.name}
                                  </Button>
                              )}
                              <IconButton
                                  size="small"
                                  onClick={() => {
                                      const next = [...priorityForm.newAttachments];
                                      next.splice(i, 1);
                                      setPriorityForm(p => ({ ...p, newAttachments: next }));
                                  }}
                                  sx={{ position: 'absolute', top: -6, right: -6, backgroundColor: 'rgba(255,255,255,0.8)' }}
                              >
                                  <CloseIcon fontSize="small" />
                              </IconButton>
                          </Box>
                      ))}
                  </Box>

                  {/* actions */}
                  <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
                      <Button onClick={handleClosePriorityEdit}>ביטול</Button>
                      <Button
                          variant="contained"
                          onClick={async () => {
                                 try {
                                       // 1) upload any new files
                                          const newlyUploaded = await uploadNewFiles(priorityForm.newAttachments);

                                          // 2) merge into attachments,
                                               //    dropping the `newAttachments` array before sending
                                                   const payload = {
                                             ...priorityForm,
                                             attachments: [
                                               ...(priorityForm.attachments || []),
                                               ...newlyUploaded,
                                             ],
                                           };
                                       delete payload.newAttachments;
                                        payload.originalPlaceId = originalPlaceId;
                                           // 3) send the PUT
                                               const resp = await fetch(
                                             `https://blue-parking-invite.bluept.dev/api/priority-receipts/${payload.id}`,
                                           {
                                               method: "PUT",
                                               headers: { "Content-Type": "application/json" },
                                           body: JSON.stringify(payload),
                                             }
                                       );
                                       if (!resp.ok) throw new Error("Save failed");

                                           // 4) refresh and close
                                               const { data } = await (await fetch(
                                            "https://blue-parking-invite.bluept.dev/api/priority-receipts"
                                           )).json();
                                      setPriorityData(data);
                                      setSnackbar({ open: true, message: "Updated!", severity: "success" });
                                       handleClosePriorityEdit();
                                     } catch (err) {
                                       console.error(err);
                                       setSnackbar({ open: true, message: "Update failed", severity: "error" });
                                     }
                               }}
                      >

                      שמור
                      </Button>
                  </Box>
              </Box>
          </Modal>

          <Modal
              open={paymentOpen}
              onClose={closePayment}
              slotProps={{
                  root: { sx: { zIndex: (t) => (t?.zIndex?.modal ?? 1300) + 200 } },
                  backdrop: { sx: { zIndex: (t) => (t?.zIndex?.modal ?? 1300) + 199, bgcolor: 'rgba(0,0,0,0.5)' } },
              }}
          >
              <Box
                  sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      bgcolor: paperBg,
                      color: textColor,
                      p: 3,
                      borderRadius: 2,
                      width: '95%',
                      maxWidth: 720,
                      boxShadow: 24,
                      zIndex: (t) => (t?.zIndex?.modal ?? 1300) + 201,
                  }}
              >
                  <Typography variant="h6" mb={2}>
                      נתוני תשלום — {paymentRow?.placeName}
                  </Typography>

                  <MaterialReactTable
                      columns={paymentColumns}
                      data={paymentData}
                      enableSorting={false}
                      enableColumnActions={false}
                      enableTopToolbar={false}
                      enableBottomToolbar={false}
                      enablePagination={false}
                      enableRowSelection={false}
                      enableStickyHeader={false}
                      initialState={{ density: 'compact' }}
                      muiTablePaperProps={{ sx: { backgroundColor: paperBg, boxShadow: 'none' } }}
                      muiTableHeadProps={{
                          sx: {
                              display: "table-header-group",
                              backgroundColor: "rgb(0,0,0)",
                              color: "white",
                              "&.Mui-TableHeadCell-Content-Wrapper": { color: "white" },
                          },
                      }}
                      muiTableBodyCellProps={{
                          sx: {
                              color: '#fff',                      // force white text
                              '& [dir="ltr"]': { color: '#fff' }, // numeric spans
                          },
                      }}
                      muiTableHeadCellProps={{
                          sx: {
                              backgroundColor: darkMode ? '#1e293b' : '#0098CF',
                              color: '#fff !important',
                              fontWeight: 'bold',
                              py: 0.5,
                              px: 1,
                              '& .Mui-TableHeadCell-Content-Wrapper': { color: '#fff' },
                              '& .MuiTableSortLabel-root': { color: '#fff !important' },
                              '& .MuiSvgIcon-root': { color: '#fff' },
                          },
                      }}

                      muiTableBodyRowProps={{ sx: { '&:last-of-type td': { borderBottom: 0 } } }}
                  />

                  <Box mt={2} display="flex" justifyContent="flex-end">
                      <Button onClick={closePayment}>סגור</Button>
                  </Box>
              </Box>
          </Modal>


          <Modal open={createOpen} onClose={() => setCreateOpen(false)}>
              <Box
                  sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      bgcolor: "#1e1e2f",
                      color: "#fff",
                      p: 3,
                      borderRadius: 3,
                      width: "95%",
                      maxWidth: 600,
                      maxHeight: "85vh",
                      overflowY: "auto",
                      boxShadow: 24,
                  }}
              >
                  <Typography variant="h6" mb={2}>הוספת אמצעי תשלום</Typography>

                  {/* בואו ניצור TextField/Checkbox חכם לכל שדה */}
                  {Object.entries(newReceipt).filter(([key]) => key !== 'attachments' && key !== 'newAttachments').map(([key, val]) => {
                      const colDef = priorityColumns.find(c => c.accessorKey === key);
                      const label = colDef?.header || key;
                      // בוליאני -> Checkbox
                      if (typeof val === "boolean") {
                          return (
                              <FormControlLabel
                                  key={key}
                                  control={
                                      <Checkbox
                                          checked={!!newReceipt[key]}
                                          onChange={e =>
                                              setNewReceipt(prev => ({ ...prev, [key]: e.target.checked }))
                                          }
                                      />
                                  }
                                  label={label}
                              />
                          );
                      }
                      // שדות מספריים
                      const isNumber = ["clientNumber","accessLimit","accountNumber","bankNumber","companyNumber","branchNum"].includes(key);
                      return (
                          <TextField
                              key={key}
                              fullWidth
                              type={isNumber ? "number" : "text"}
                              label={label}
                              value={newReceipt[key] ?? ""}
                              onChange={e =>
                                  setNewReceipt(prev => ({ ...prev, [key]: e.target.value }))
                              }
                              margin="normal"
                          />
                      );

                  })}
                  <Button variant="outlined" component="label" sx={{ mt: 2 }}>
                      בחירת קבצים
                      <input
                          type="file"
                          hidden
                          multiple
                          onChange={e => handleFileChange(e)}
                      />
                  </Button>
                  {newReceipt.attachments?.map((att, idx) => (
                      <div style={{marginTop: "10px"}}>
                      <Box key={`new-${idx}`} sx={{ position: "relative", display: "inline-block" }}>
                          {att.previewUrl && att.type?.includes("image") ? (
                              <img
                                  src={att.previewUrl}
                                  alt={att.name}
                                  style={{ width: 100, height: 100, objectFit: "cover" }}
                              />
                          ) : att.previewUrl && att.type?.includes("video") ? (
                              <video
                                  src={att.previewUrl}
                                  style={{ width: 100, height: 100 }}
                                  controls
                              />
                          ) : (
                              <Button variant="text" color="info">
                                  {att.name}
                              </Button>
                          )}
                          <IconButton
                              size="small"
                              onClick={() => handleRemoveAttachment(idx, false)}
                              sx={{
                                  position: "absolute",
                                  top: -8,
                                  right: -8,
                                  backgroundColor: "rgba(255,255,255,0.8)",
                                  "&:hover": { backgroundColor: "rgba(255,255,255,1)" },
                              }}
                          >
                              <CloseIcon fontSize="small" />
                          </IconButton>
                      </Box></div>
                  ))}
                  <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
                      <Button onClick={() => setCreateOpen(false)}>ביטול</Button>
                      <Button
                          variant="contained"
                       onClick={async () => {
                         try {
                               const newlyUploaded = await uploadNewFiles(newReceipt.attachments);

                                   const payload = {
                                     ...newReceipt,
                                     attachments: newlyUploaded,
                                   };
                               delete payload.newAttachments;

                                   const resp = await fetch(
                                     "https://blue-parking-invite.bluept.dev/api/priority-receipts",
                                     {
                                       method: "POST",
                                       headers: { "Content-Type": "application/json" },
                                  body: JSON.stringify(payload),
                                     }
                              );
                               if (!resp.ok) throw new Error("Create failed");

                                  const { data } = await (await fetch(
                                     "https://blue-parking-invite.bluept.dev/api/priority-receipts"
                                   )).json();
                               setPriorityData(data);
                               setSnackbar({ open: true, message: "Created!", severity: "success" });
                              setCreateOpen(false);
                             } catch (err) {
                               console.error(err);
                               setSnackbar({ open: true, message: "Create failed", severity: "error" });
                             }
                       }}
                          disabled={!newReceipt.placeId.trim()}
                      >
                          שמור
                      </Button>
                  </Box>
              </Box>
          </Modal>

        {/* Add Modal */}
        <Modal open={addOpen} onClose={handleCloseAdd}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "#1e1e2f",
              color: "#fff",
              p: 3,
              borderRadius: 3,
              width: "95%",
              maxWidth: 600,
              maxHeight: "85vh",
              overflowY: "auto",
              boxShadow: 24,
            }}
          >
            <Typography variant="h6" mb={2}>
              הוסף
            </Typography>

            {errorMsg && <Alert severity="error">{errorMsg}</Alert>}

            <AsyncSearch
              value={form.placeName}
              onValueChange={(pname, pid) => handleAddEventChangePlace(pname, pid)}
            />

            {[
              { label: "מס' לקוח", name: "clientNum", type: "number" },
              { label: "שם החברה", name: "companyName" },
              {
                label: "אחוזי פנגו",
                name: "pangoCommissionPercentage",
                type: "number",
                inputProps: { step: 0.1, min: 0, max: 100 },
              },
              {
                label: "אחוזי סלו",
                name: "celloCommissionPercentage",
                type: "number",
                inputProps: { step: 0.1, min: 0, max: 100 },
              },
              {
                label: "אחוזי אשראי",
                name: "ccardCommissionPercentage",
                type: "number",
                inputProps: { step: 0.1, min: 0, max: 100 },
              },
              { label: "Stations №", name: "stationsNum", type: "number" },
              {
                label: "מחיר דיגיטל חודשי",
                name: "monthlyDigitalPrice",
                type: "number",
                inputProps: { min: 0 },
              },
              {
                label: "מחיר טרמינל חודשי",
                name: "monthlyTerminalPrice",
                type: "number",
                inputProps: { min: 0 },
              },
                {
                    label: "אתר",
                    name: "DCODE",
                },
                {
                    label: "תאריך תחילת חוזה",
                    name: "contractStartDate",
                    type: "date",
                },
                {
                    label: "תאריך סיום חוזה",
                    name: "contractEndDate",
                    type: "date",
                },
                {
                    label: "חוזה לא פעיל",
                    name: "contractNotActive",
                    type: "checkbox",
                },
                {
                    label: "תאריך ממנו החוזה לא פעיל",
                    name: "notActiveFrom",
                    type: "date",
                },
            ].map(({ label, name, ...rest }) => (
                name === 'contractNotActive' ?
                <FormControlLabel
                key={name}
                control={
                  <Checkbox
                    checked={!!form[name]}
                    onChange={handleChange(name)}
                  />
                }
                label={label}
                /> :
              <TextField
                key={name}
                fullWidth
                label={label}
                value={form[name]}
                onChange={handleChange(name)}
                margin="normal"
                {...rest}
              />
            ))}

            <FormControl fullWidth margin="normal">
              <InputLabel id="contract-type-label">סוג החוזה</InputLabel>
              <Select
                labelId="contract-type-label"
                value={form.contractType}
                onChange={(e) =>
                  setForm((f) => ({
                    ...f,
                    contractType: parseInt(e.target.value, 10),
                  }))
                }
                label="סוג החוזה"
                sx={{ height: 44 }}
              >
                {Object.entries(CONTRACT_TYPES).map(([value, label]) => (
                  <MenuItem key={value} value={parseInt(value, 10)}>
                    {label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

              <FormControl fullWidth margin="normal">
                  <InputLabel id="pay-cond-label">תנאי תשלום</InputLabel>
                  <Select
                      labelId="pay-cond-label"
                      label="תנאי תשלום"
                      value={form.pay_condition || DEFAULT_PAY_CONDITION}
                      onChange={(e) => handlePayCondChange(e.target.value)}
                      sx={{ height: 44 }}
                  >
                      {PAY_CONDITIONS.map((opt) => (
                          <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                      ))}
                  </Select>
              </FormControl>

              {/* קבצים */}
              <Button variant="outlined" component="label" sx={{ mt: 2 }}>
                  בחירת קבצים
                  <input type="file" hidden multiple onChange={(e) => {
                      const files = Array.from(e.target.files);
                      processAttachmentBatch(files).then((trimmed) => {
                          setForm(prev => ({ ...prev, newAttachments: [...(prev.newAttachments||[]), ...trimmed] }));
                      });
                  }} />
              </Button>

              {/* Previews for existing + newly picked */}
              <Box sx={{ display:'flex', gap:1, flexWrap:'wrap', mt:2 }}>
                  {(form.attachments || []).map((att, i) => (
                      <Box key={`old-${i}`} sx={{ position:'relative' }}>
                          {renderAttachmentPreview(att, i)}
                          <IconButton
                              size="small"
                              onClick={() => {
                                  const next = [...form.attachments]; next.splice(i,1);
                                  setForm(prev => ({ ...prev, attachments: next }));
                              }}
                              sx={{ position:'absolute', top:-6, right:-6, backgroundColor:'rgba(255,255,255,0.8)' }}
                          >
                              <CloseIcon fontSize="small" />
                          </IconButton>
                      </Box>
                  ))}
                  {(form.newAttachments || []).map((att, i) => (
                      <Box key={`new-${i}`} sx={{ position:'relative' }}>
                          {att.type.startsWith('image/')
                              ? <img src={att.previewUrl} style={{ width:80, height:80, objectFit:'cover' }} />
                              : att.type.startsWith('video/')
                                  ? <video src={att.previewUrl} muted preload="metadata" style={{ width:80, height:80, objectFit:'cover' }} />
                                  : <Button variant="text" onClick={() => handleDownload(att.url, att.name)}>{att.name}</Button>}
                          <IconButton
                              size="small"
                              onClick={() => {
                                  const next = [...form.newAttachments]; next.splice(i,1);
                                  setForm(prev => ({ ...prev, newAttachments: next }));
                              }}
                              sx={{ position:'absolute', top:-6, right:-6, backgroundColor:'rgba(255,255,255,0.8)' }}
                          >
                              <CloseIcon fontSize="small" />
                          </IconButton>
                      </Box>
                  ))}
              </Box>

            {/* <PriorityEmailAccordion form={form} setForm={setForm} /> */}
            <PriorityEmailTableAccordion form={form} setForm={setForm} />

            <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
              <Button onClick={handleCloseAdd} variant="text" color="inherit">
                ביטול
              </Button>
              <Button
                variant="contained"
                onClick={() => handleSubmit(false)}
                disabled={!validateForm()}
              >
                שמור
              </Button>
            </Box>
          </Box>
        </Modal>

        {/* Edit Modal */}
        <Modal open={editOpen} onClose={handleCloseEdit}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "#1e1e2f",
              color: "#fff",
              p: 3,
              borderRadius: 3,
              width: "95%",
              maxWidth: 600,
              maxHeight: "85vh",
              overflowY: "auto",
              boxShadow: 24,
            }}
          >
            <Typography variant="h6" mb={2}>
              עריכת לקוח
            </Typography>

            {errorMsg && <Alert severity="error">{errorMsg}</Alert>}

              {form.placeId !== 1 && form.clientNum!==1 && <AsyncSearch
              value={form.placeName}
              onValueChange={(pname, pid) => handleAddEventChangePlace(pname, pid)}
            />}

              {form.placeId !== 1 && form.clientNum!==1 &&
                  [{ label: "מס' לקוח", name: "clientNum", type: "number" },
              { label: "שם החברה", name: "companyName" },
              {
                  label: "אחוזי פנגו",
                  name: "pangoCommissionPercentage",
                  type: "number",
                  inputProps: { step: 0.1, min: 0, max: 100 },
              },
              {
                  label: "אחוזי סלו",
                  name: "celloCommissionPercentage",
                  type: "number",
                  inputProps: { step: 0.1, min: 0, max: 100 },
              },
              {
                  label: "אחוזי אשראי",
                  name: "ccardCommissionPercentage",
                  type: "number",
                  inputProps: { step: 0.1, min: 0, max: 100 },
              },
              { label: "מס' עמדות", name: "stationsNum", type: "number" },
              {
                  label: "מחיר דיגיטל חודשי",
                  name: "monthlyDigitalPrice",
                  type: "number",
                  inputProps: { min: 0 },
              },
              {
                  label: "מחיר טרמינל חודשי",
                  name: "monthlyTerminalPrice",
                  type: "number",
                  inputProps: { min: 0 },
              },
              {
                  label: "אתר",
                  name: "DCODE",
              },
              {
                  label: "תאריך תחילת החוזה",
                  name: "contractStartDate",
                  type: "date",
              },
              {
                  label: "תאריך סיום החוזה",
                  name: "contractEndDate",
                  type: "date",
              },
                      {
                          label: "חוזה לא פעיל",
                          name: "contractNotActive",
                          type: "checkbox",
                      },
                      {
                          label: "תאריך ממנו החוזה לא פעיל",
                          name: "notActiveFrom",
                          type: "date",
                      },
          ].map(({ label, name, ...rest }) => (
                      name === 'contractNotActive' ?
                          <FormControlLabel
                              key={name}
                              control={
                                  <Checkbox
                                      checked={!!form[name]}
                                      onChange={handleChange(name)}
                                  />
                              }
                              label={label}
                          />                          :
                          <TextField
                  key={name}
                  fullWidth
                  label={label}
                  value={form[name]}
                  onChange={handleChange(name)}
                  margin="normal"
                  {...rest}
              />
            ))}

            {form.placeId == 1 && form.clientNum==1 && [{ label: "Company Name", name: "companyName" },
              {
                label: "Pango %",
                name: "pangoCommissionPercentage",
                type: "number",
                inputProps: { step: 0.1, min: 0, max: 100 },
              },
              {
                label: "Cello %",
                name: "celloCommissionPercentage",
                type: "number",
                inputProps: { step: 0.1, min: 0, max: 100 },
              },
              {
                label: "CCard %",
                name: "ccardCommissionPercentage",
                type: "number",
                inputProps: { step: 0.1, min: 0, max: 100 },
              },
              { label: "Stations №", name: "stationsNum", type: "number" },
              {
                label: "Digital Price (₪/mo)",
                name: "monthlyDigitalPrice",
                type: "number",
                inputProps: { min: 0 },
              },
              {
                label: "Terminal Price (₪/mo)",
                name: "monthlyTerminalPrice",
                type: "number",
                inputProps: { min: 0 },
              },
                {
                    label: "Site",
                    name: "DCODE",
                },
                {
                    label: "Contract start date",
                    name: "contractStartDate",
                    type: "date",
                },
                {
                    label: "Contract end date",
                    name: "contractEndDate",
                    type: "date",
                },
                {
                    label: "Contract not active",
                    name: "contractNotActive",
                    type: "checkbox",
                },
                {
                    label: "Contract not active from",
                    name: "notActiveFrom",
                    type: "date",
                },
            ].map(({ label, name, ...rest }) => (
                name === 'contractNotActive' ?
                <FormControlLabel
                key={name}
              control={
                  <Checkbox
                      checked={!!form[name]}
                      onChange={handleChange(name)}
                  />
              }
              label={label}
          />:
            <TextField
                key={name}
                fullWidth
                label={label}
                value={form[name]}
                onChange={handleChange(name)}
                margin="normal"
                {...rest}
              />
            ))}

            <FormControl fullWidth margin="normal">
              <InputLabel id="contract-type-label">סוג חוזה</InputLabel>
              <Select
                labelId="contract-type-label"
                value={form.contractType}
                onChange={(e) =>
                  setForm((f) => ({ ...f, contractType: parseInt(e.target.value, 10) }))
                }
                label="סוג החוזה"
                sx={{ height: 44 }}
              >
                {Object.entries(CONTRACT_TYPES).map(([value, label]) => (
                  <MenuItem key={value} value={parseInt(value, 10)}>
                    {label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

              {/* תנאי תשלום */}
              <FormControl fullWidth margin="normal">
                  <InputLabel id="pay-cond-label">תנאי תשלום</InputLabel>
                  <Select
                      labelId="pay-cond-label"
                      label="תנאי תשלום"
                      value={form.pay_condition || DEFAULT_PAY_CONDITION}
                      onChange={(e) => handlePayCondChange(e.target.value)}
                      sx={{ height: 44 }}
                  >
                      {PAY_CONDITIONS.map((opt) => (
                          <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                      ))}
                  </Select>
              </FormControl>

              {/* קבצים */}
              <Button variant="outlined" component="label" sx={{ mt: 2 }}>
                  בחירת קבצים
                  <input type="file" hidden multiple onChange={(e) => {
                      const files = Array.from(e.target.files);
                      processAttachmentBatch(files).then((trimmed) => {
                          setForm(prev => ({ ...prev, newAttachments: [...(prev.newAttachments||[]), ...trimmed] }));
                      });
                  }} />
              </Button>

              {/* Previews for existing + newly picked */}
              <Box sx={{ display:'flex', gap:1, flexWrap:'wrap', mt:2 }}>
                  {(form.attachments || []).map((att, i) => (
                      <Box key={`old-${i}`} sx={{ position:'relative' }}>
                          {renderAttachmentPreview(att, i)}
                          <IconButton
                              size="small"
                              onClick={() => {
                                  const next = [...form.attachments]; next.splice(i,1);
                                  setForm(prev => ({ ...prev, attachments: next }));
                              }}
                              sx={{ position:'absolute', top:-6, right:-6, backgroundColor:'rgba(255,255,255,0.8)' }}
                          >
                              <CloseIcon fontSize="small" />
                          </IconButton>
                      </Box>
                  ))}
                  {(form.newAttachments || []).map((att, i) => (
                      <Box key={`new-${i}`} sx={{ position:'relative' }}>
                          {att.type.startsWith('image/')
                              ? <img src={att.previewUrl} style={{ width:80, height:80, objectFit:'cover' }} />
                              : att.type.startsWith('video/')
                                  ? <video src={att.previewUrl} muted preload="metadata" style={{ width:80, height:80, objectFit:'cover' }} />
                                  : <Button variant="text" onClick={() => handleDownload(att.url, att.name)}>{att.name}</Button>}
                          <IconButton
                              size="small"
                              onClick={() => {
                                  const next = [...form.newAttachments]; next.splice(i,1);
                                  setForm(prev => ({ ...prev, newAttachments: next }));
                              }}
                              sx={{ position:'absolute', top:-6, right:-6, backgroundColor:'rgba(255,255,255,0.8)' }}
                          >
                              <CloseIcon fontSize="small" />
                          </IconButton>
                      </Box>
                  ))}
              </Box>

              <PriorityEmailTableAccordion form={form} setForm={setForm} />
            <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
              <Button onClick={handleCloseEdit} variant="text" color="inherit">
                ביטול
              </Button>
              <Button
                variant="contained"
                onClick={() => handleSubmit(true)}
                disabled={!validateForm()}
              >
                שמור
              </Button>
            </Box>
          </Box>
        </Modal>
        <Modal open={debtModalOpen} onClose={closeDebtModal}>
            <Box
                sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: paperBg,
                color: textColor,
                p: 3,
                borderRadius: 2,
                width: '95%',
                maxWidth: 420,
                boxShadow: 24
                }}
            >
                <Typography variant="h6" mb={2} sx={{ fontWeight: 700 }}>
                יצירת חוב
                </Typography>

                <TextField
                fullWidth
                label="חוב בסך"
                type="number"
                value={debtForm.amount}
                onChange={(e) => setDebtForm(f => ({ ...f, amount: e.target.value }))}
                margin="normal"
                inputProps={{ min: 0, step: '0.01' }}
                sx={{
                    '& .MuiInputBase-root': {
                    bgcolor: darkMode ? '#1e293b' : '#f2f6fa',
                    borderRadius: 1.2,
                    },
                    '& .MuiInputBase-input': {
                    color: textColor,
                    fontWeight: 500,
                    },
                    '& label': { color: darkMode ? '#ccc' : '#555' },
                    '& label.Mui-focused': { color: darkMode ? '#fff' : '#0098CF' },
                    // remove chrome number arrows + white background
                    '& input[type=number]': {
                    MozAppearance: 'textfield',
                    },
                    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                    WebkitAppearance: 'none',
                    margin: 0,
                    },
                }}
                />

                <TextField
                fullWidth
                label="תאריך החוב"
                type="date"
                value={debtForm.date}
                onChange={(e) => setDebtForm(f => ({ ...f, date: e.target.value }))}
                margin="normal"
                InputLabelProps={{ shrink: true }}
                sx={{
                    '& .MuiInputBase-root': {
                    bgcolor: darkMode ? '#1e293b' : '#f2f6fa',
                    borderRadius: 1.2,
                    },
                    '& .MuiInputBase-input': {
                    color: textColor,
                    fontWeight: 500,
                    },
                    '& label': { color: darkMode ? '#ccc' : '#555' },
                    '& label.Mui-focused': { color: darkMode ? '#fff' : '#0098CF' },
                }}
                />
                <TextField
                fullWidth
                label="אימייל"
                type="email"
                value={debtForm.email}
                onChange={(e) => setDebtForm(f => ({ ...f, email: e.target.value }))}
                margin="normal"
                InputLabelProps={{ shrink: true }}
                />

                <TextField
                fullWidth
                label="טלפון"
                type="tel"
                value={debtForm.phone}
                onChange={(e) => setDebtForm(f => ({ ...f, phone: e.target.value }))}
                margin="normal"
                InputLabelProps={{ shrink: true }}
                />
                <Box mt={3} display="flex" justifyContent="flex-end" gap={1.5}>
                <Button
                    variant="outlined"
                    onClick={closeDebtModal}
                    disableRipple
                    sx={{
                    textTransform: 'none',
                    fontWeight: 600,
                    px: 2.5,
                    py: 0.75,
                    color: textColor,
                    borderColor: darkMode ? '#555' : '#0098CF',
                    '&:hover': {
                        borderColor: darkMode ? '#777' : '#007AAF',
                        bgcolor: 'transparent',
                    },
                    }}
                >
                    ביטול
                </Button>
                <Button
                    variant="contained"
                    onClick={handleDebtCreate}
                    disabled={!debtForm.amount || !debtForm.date || (!debtForm.email && !debtForm.phone)}
                    disableRipple
                    sx={{
                    textTransform: 'none',
                    fontWeight: 700,
                    px: 2.8,
                    py: 0.75,
                    boxShadow: 'none',
                    bgcolor: darkMode ? '#0098CF' : '#0098CF',
                    '&:hover': {
                        boxShadow: 'none',
                        bgcolor: darkMode ? '#07a8e3' : '#07a8e3',
                    },
                    '&.Mui-disabled': {
                        bgcolor: darkMode ? '#0d3d52' : '#9ecfe4',
                        color: darkMode ? 'rgba(255,255,255,0.5)' : '#ffffff',
                    },
                    }}
                >
                    צור
                </Button>
                </Box>
                <Backdrop open={debtCreating} sx={{ color: '#fff', zIndex: (t) => (t?.zIndex?.modal ?? 1300) + 1 }}>
                    <CircularProgress color="inherit" size={64} thickness={4.5}  />
                </Backdrop>
            </Box>
        </Modal>

        <Modal open={sendDebtOpen} onClose={closeSendDebtModal}>
            <Box
            sx={{
                position: 'absolute',
                top: '50%', left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: paperBg, color: textColor,
                p: 3, borderRadius: 2, width: '95%', maxWidth: 520, boxShadow: 24,
            }}
            >
            <Typography variant="h6" mb={2} sx={{ fontWeight: 700 }}>
                שליחת הודעת חוב
            </Typography>

            <TextField
                fullWidth
                label="סכום לתשלום (₪)"
                type="number"
                value={sendDebtForm.amount}
                onChange={(e) => setSendDebtForm(f => ({ ...f, amount: e.target.value }))}
                margin="normal"
                inputProps={{ min: 0, step: '0.01', inputMode: 'decimal' }}
                InputLabelProps={{ shrink: true }}
                error={sendDebtForm.amount !== '' && !isPositiveAmount(sendDebtForm.amount)}
                helperText={
                    sendDebtForm.amount !== '' && !isPositiveAmount(sendDebtForm.amount)
                    ? 'הזן סכום גדול מ-0'
                    : ''
                }
            />

            <TextField
                fullWidth
                label="שם לקוח"
                value={sendDebtForm.name}
                onChange={(e) => setSendDebtForm(f => ({ ...f, name: e.target.value }))}
                margin="normal"
                InputLabelProps={{ shrink: true }}
            />

            <TextField
                fullWidth
                label="טלפון"
                type="tel"
                value={sendDebtForm.phone}
                onChange={(e) => setSendDebtForm(f => ({ ...f, phone: e.target.value }))}
                margin="normal"
                InputLabelProps={{ shrink: true }}
                  error={sendDebtForm.channels.whatsapp && !isValidPhone(sendDebtForm.phone)}
  helperText={
    sendDebtForm.channels.whatsapp && !isValidPhone(sendDebtForm.phone)
      ? 'מספר טלפון לא תקין לשליחת וואטסאפ'
      : ''
  }
            />

            <TextField
                fullWidth
                label="אימייל"
                type="email"
                value={sendDebtForm.email}
                onChange={(e) => setSendDebtForm(f => ({ ...f, email: e.target.value }))}
                margin="normal"
                InputLabelProps={{ shrink: true }}
                  error={sendDebtForm.channels.email && !isValidEmail(sendDebtForm.email)}
  helperText={
    sendDebtForm.channels.email && !isValidEmail(sendDebtForm.email)
      ? 'אימייל לא תקין'
      : ''
  }
            />

            <FormControlLabel
            control={
                <Checkbox
                checked={!!sendDebtForm.includeAttachment}
                onChange={(e) =>
                    setSendDebtForm(f => ({
                    ...f,
                    includeAttachment: e.target.checked,
                    // clear selection when turning off
                    ...(e.target.checked ? {} : { attachmentUrl: '', attachmentName: '' }),
                    }))
                }
                />
            }
            label="צרף קובץ"
            />

            {sendDebtForm.includeAttachment && (
            <FormControl fullWidth margin="normal">
                <InputLabel id="att-select-label">בחר קובץ מצורף</InputLabel>
                <Select
                labelId="att-select-label"
                label="בחר קובץ מצורף"
                value={sendDebtForm.attachmentUrl || ''}
                onChange={(e) => {
                    const url = e.target.value;
                    const att = (sendDebtRow?.attachments || []).find(a => a.url === url);
                    setSendDebtForm(f => ({
                    ...f,
                    attachmentUrl: url,
                    attachmentName: att?.name || att?.fileName || '',
                    }));
                }}
                sx={{ height: 44 }}
                >
                {(sendDebtRow?.attachments || []).map((att, i) => (
                    <MenuItem key={i} value={att.url}>
                    {att.name || att.fileName || att.url}
                    </MenuItem>
                ))}
                </Select>
            </FormControl>
            )}

            <Box mb={2}>
                <FormControlLabel
                control={
                    <Checkbox
                    checked={sendDebtForm.channels.email}
                    onChange={(e) =>
                        setSendDebtForm(f => ({ ...f, channels: { ...f.channels, email: e.target.checked } }))
                    }
                    />
                }
                label="שליחה במייל"
                />
                <FormControlLabel
                control={
                    <Checkbox
                    checked={sendDebtForm.channels.whatsapp}
                    onChange={(e) =>
                        setSendDebtForm(f => ({ ...f, channels: { ...f.channels, whatsapp: e.target.checked } }))
                    }
                    />
                }
                label="שליחה בוואטסאפ"
                />
            </Box>

            <Box display="flex" justifyContent="flex-end" gap={1.5}>
                <Button variant="text" onClick={closeSendDebtModal}>בטל</Button>
                <Button
                variant="contained"
                onClick={handleSendDebtSubmit}
                disabled={
                    (sendDebtForm.includeAttachment && !sendDebtForm.attachmentUrl) ||
                    (!sendDebtForm.channels.email && !sendDebtForm.channels.whatsapp) ||
                    (sendDebtForm.channels.email && !isValidEmail(sendDebtForm.email)) ||
                    (sendDebtForm.channels.whatsapp && !isValidPhone(sendDebtForm.phone)) ||
                    !isPositiveAmount(sendDebtForm.amount)
                }
                >
                שלח
                </Button>
            </Box>
            </Box>
        </Modal>
      
        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    </DashboardLayout>
  );
};

export default PlaceCommissions;
